"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2339],{

/***/ 12535:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-brake-repair-header.e9c70732.jpeg","height":650,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQMREgITUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8Amm3NtyyLN3IWeAAFf//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 57581:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-brake-repair-header.e9c70732.jpg","height":650,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQMREgITUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8Amm3NtyyLN3IWeAAFf//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 85604:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/vioc-logo.f45fde1d.png","height":984,"width":1080,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAATlBMVEXxh4LolJDnbWfnVE30Y1z0Vk36kIn29PTwb2jpoZ3yenT8gnnq9/sAf8Wth5IjruIlZp/Z4udZsdjn3t6wLDjqCgCLxd6Jxd5hSnB4zetAk6nbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nB3BBw7AMAgDQIcQDBnd8/8frdQ77BHs172Cfto7NoIsx5g7ESbPMrVAVlRrJUOKa3UVJPzSB03DAeg68BtgAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 56018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ WhatToExpectSection; },
/* harmony export */   "v": function() { return /* binding */ ReasonWhyItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3210);
/* harmony import */ var _GraySection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18737);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faWrench__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88302);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68481);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faHandHoldingUsd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64951);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faSeedling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92633);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faUsers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15073);










var WhatToExpectSection = function() {
    // const item = {
    //   title: 'REPAIRS AROUND YOUR SCHEDULE',
    //   subheading:
    //     'Life’s busy. So why waste your time sitting at a shop? Our brake techs come to you and repair your brakes around your schedule.',
    //   icon: faWrench,
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GraySection__WEBPACK_IMPORTED_MODULE_3__/* .GraySection */ .g, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: "What To Expect"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description",
                    children: "Our technicians are the backbone of our business and we treat all team members like family. When you join the NuBrakes team, you’ll be given the tools and support needed to succeed."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "Top Industry Pay",
                            icon: _fortawesome_pro_duotone_svg_icons_faHandHoldingUsd__WEBPACK_IMPORTED_MODULE_5__/* .faHandHoldingUsd */ .oF,
                            subheading: "Our pay plan puts the ball in your court! We offer a guaranteed base salary, but there is no limit on what you can earn! Almost all of our techs exceed their base pay in a matter of weeks."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "Opportunity for growth",
                            icon: _fortawesome_pro_duotone_svg_icons_faSeedling__WEBPACK_IMPORTED_MODULE_6__/* .faSeedling */ .YK,
                            subheading: "We’re a high-growth startup and we’re reinventing the brake repair industry. We believe in a hire-from-within mentality and a high-growth company means opportunity to move up in your career."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "A Sense Of Team & Belonging",
                            icon: _fortawesome_pro_duotone_svg_icons_faUsers__WEBPACK_IMPORTED_MODULE_7__/* .faUsers */ .FV,
                            subheading: "Team is core to NuBrakes. We all help each other & work as a team to serve our customers. Our goal is to provide you with the support and tools you need to be successful each and every day."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "Top-NOTCH SERVICE VEHICLE & EQUIPMENT",
                            icon: _fortawesome_free_solid_svg_icons_faWrench__WEBPACK_IMPORTED_MODULE_8__/* .faWrench */ .kl,
                            subheading: "We’ll provide you with a brand new, 2020 Nissan NV200 company service vehicle and all of the tools/equipment you need to deliver a 5 star service."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "OFFICE & CUSTOMER SUPPORT",
                            icon: _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_9__/* .faShieldCheck */ .ip,
                            subheading: "Our Customer Service and Dispatch team is here to back you up. We have a stellar staff handling the customer interaction so you can focus on the task at hand."
                        })
                    ]
                })
            ]
        })
    });
};
var ReasonWhyItem = function(param) {
    var title = param.title, subheading = param.subheading, icon = param.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-grow flex-col h-100 py-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                    size: "4x",
                    icon: icon,
                    color: "#ea3616"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        style: {
                            paddingTop: 20,
                            fontSize: 18,
                            fontWeight: 900
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "m-0 description",
                        children: subheading
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 63549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BgImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_img_nubrakes_brake_repair_header_jpg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57581);



var BgImage = function(param) {
    var src = param.src, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center align-center relative h-[45vh] sm:h-[60vh]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src !== null && src !== void 0 ? src : _public_img_nubrakes_brake_repair_header_jpg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                alt: "NuBrakes Background Image",
                layout: "fill",
                objectFit: "cover",
                objectPosition: "top left"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    zIndex: 1
                },
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 32758:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: BuilderServicesHowItWorksSection

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(18202);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/capital-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(71292);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./src/components/SEMPage/CityPhoneNumberData.tsx
var CityPhoneNumberData = __webpack_require__(21611);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCalendarCheck.js
var faCalendarCheck = __webpack_require__(52375);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCarMechanic.js
var faCarMechanic = __webpack_require__(67170);
// EXTERNAL MODULE: ./src/components/SEMPage/HowItWorksGreenCheckSection.tsx
var HowItWorksGreenCheckSection = __webpack_require__(43906);
// EXTERNAL MODULE: ./src/components/ReviewsV2Section.tsx
var ReviewsV2Section = __webpack_require__(18405);
// EXTERNAL MODULE: ./src/components/SEMPage/getTitleFromUTMS.tsx
var getTitleFromUTMS = __webpack_require__(10090);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/SEMPage/ServicesHowItWorksSection.tsx
var ServicesHowItWorksSection = __webpack_require__(1948);
// EXTERNAL MODULE: ./src/components/HappinessGuaranteeSection.tsx
var HappinessGuaranteeSection = __webpack_require__(28763);
// EXTERNAL MODULE: ./src/components/CallUsNowBar.tsx
var CallUsNowBar = __webpack_require__(11667);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormMultiStep.tsx + 2 modules
var NoEmailScheduleServiceFormMultiStep = __webpack_require__(42786);
// EXTERNAL MODULE: ./src/components/SEMPage/HeaderSectionVariation.tsx
var HeaderSectionVariation = __webpack_require__(33009);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faMoneyCheckEditAlt.js
var faMoneyCheckEditAlt = __webpack_require__(38510);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/SEMPage/SEMVariation.tsx























var SEMIndexPageTemplate = function(param) {
    var phoneNumber = param.phoneNumber, formalCity = param.formalCity, phoneNumberTxt = param.phoneNumberTxt, _type = param.type, type = _type === void 0 ? "generic" : _type, content = param.content, make = param.make, rating = param.rating, reviewCount = param.reviewCount;
    var headerTitle = (0,getTitleFromUTMS/* getTitleFromUTMS */.u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        showFooter: false,
        showGetQuote: false,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        title: "Affordable Brake Repair Services".concat(formalCity ? " In ".concat(formalCity) : "", " | NuBrakes Mobile Brake Repair - We Come To You"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Need new brakes? Stay at home and let a certified NuBrakes brake tech come to you and repair your brakes for less than most".concat(formalCity ? " ".concat(formalCity) : "", " brake shops and dealerships on average.")
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSectionVariation/* default */.Z, {
                rating: rating,
                formInitialProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA), {
                    "form-name": "semScheduleServiceForm"
                }),
                reviewCount: reviewCount,
                title: headerTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksGreenCheckSection/* HowItWorksGreenCheckSection */.x, {
                title: "Why NuBrakes?",
                first: {
                    title: "We Come To You",
                    subtitle: "Our mobile brake techs deliver top-rated brake repairs at your home or office for up to 40% less than a repair shop."
                },
                second: {
                    title: "Better Prices",
                    subtitle: "We're 40% more affordable on average compared to the dealerships and shops so you'll be saving time and money."
                },
                third: {
                    title: "Same-Day Availability",
                    subtitle: "Need your brakes repaired today? Same-day service is typically available — contact us to schedule!"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesHowItWorksSection/* ServicesHowItWorksSection */.S, {
                phoneNumber: phoneNumber,
                title: "How NuBrakes Works",
                description: "Schedule top-rated brake services in minutes.",
                steps: [
                    {
                        title: "Get Your Free Repair Quote",
                        description: "Let us know what’s going on with your brakes and we’ll send you a free, no obligation repair quote for your vehicle.",
                        image: faMoneyCheckEditAlt/* faMoneyCheckEditAlt */.v4
                    },
                    {
                        title: "Select Your Repair Date",
                        description: "Availability as early as today. Choose a repair date and time that works around your schedule.",
                        image: faCalendarCheck/* faCalendarCheck */.Ry
                    },
                    {
                        title: "Enjoy Safer, Better Driving",
                        description: "Our brake technicians will ensure that your brakes are ready to hit the road and get you back to driving worry-free!",
                        image: faCarMechanic/* faCarMechanic */.cC
                    }, 
                ],
                buttonText: "Get A Quote"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsV2Section/* ReviewsV2Section */.r, {
                title: "Over 1000+ 5-Star Reviews",
                first: {
                    review: "We received fantastic, quick service, at a fair price. We got quite a few quotes and NuBrakes was the best price and it turns out, the quickest and best service. Our technician, Mike, was knowledgeable and friendly and got the job done quickly - all at my office. We would definitely recommend them and use the service again.",
                    from: "".concat(formalCity),
                    reviewer: "Tami F."
                },
                second: {
                    from: "".concat(formalCity),
                    reviewer: "Clinton B.",
                    review: "This service is awesome. You are paying for fast, convenient and good quality work. Communication with Walker was immediate and the technician Micheal was done in half the time that was quoted. I will use NuBrakes again in the future and recommend it to everyone. I mean, they come to you, that was what sold it for me."
                },
                third: {
                    review: "Without a doubt would recommend NuBrakes to anyone that needs brakes done. Service tech showed up on time and was professional and quick. And the conveniences having them come to you is hard to beat. Not to mention the price is close to half what you’d pay at a pep boys or any other body shop. Can’t beat it.",
                    from: "".concat(formalCity),
                    reviewer: "William T."
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection/* HappinessGuaranteeSection */.M, {
                title: "Happiness Guaranteed",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Our brake techs have decades of combined experience, and all services are backed by our",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/warranty",
                            children: "NuBrakes Guarantee"
                        }),
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUsNowBar/* CallUsNowBar */.y, {
                phoneNumber: phoneNumber
            })
        ]
    });
};
function setContentWithFallbacks(type, content) {
    if (content !== "undefined") {
        return content;
    }
    switch(type){
        case "generic":
            return "";
        case "comp":
            return "brake shop";
        case "vehicle":
            return "";
        case "vehicle-part":
            return "brake-parts";
        case "mm_generic":
            return "auto-parts";
        case "mm_vehicle-part":
            return "auto-parts";
        default:
            return "";
    }
}
var SEMPageVariation = function(param) {
    var rating = param.rating, reviewCount = param.reviewCount;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var city = (0,es/* propOr */.Uth)("", "city", query);
    var type = (0,es/* propOr */.Uth)("", "type", query);
    var make = (0,es/* propOr */.Uth)("", "make", query);
    var content = (0,es/* propOr */.Uth)("", "utm_content", query);
    content = setContentWithFallbacks(type, content);
    var formalCity = city ? dist_es2015/* capitalCase */.I(city) : "";
    var phoneNumber = city && CityPhoneNumberData/* CityPhoneNumberData */.L[city] ? CityPhoneNumberData/* CityPhoneNumberData */.L[city].phoneNumber : CityPhoneNumberData/* CityPhoneNumberData.default.phoneNumber */.L["default"].phoneNumber;
    var phoneNumberTxt = (0,string_utils/* formatPhoneNumber */.u)(phoneNumber);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SEMIndexPageTemplate, {
        rating: rating,
        reviewCount: reviewCount,
        phoneNumberTxt: phoneNumberTxt,
        phoneNumber: phoneNumber,
        formalCity: formalCity,
        content: content,
        type: type,
        make: make
    });
};
/* harmony default export */ var SEMVariation = (SEMPageVariation);

;// CONCATENATED MODULE: ./src/components/Builder/templates/BaseLayoutTemplate.tsx




var BasePageTemplate = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayoutWithChildren, {
        description: props.description,
        robots: props.robots,
        showGetQuote: props.showGetQuote,
        showFooter: props.showFooter,
        title: props.title,
        ogImage: props.ogImage,
        phoneNumber: props.phoneNumber,
        footerDisclaimer: props.footerDisclaimer,
        locale: props.locale,
        callUsNowTitle: props.callUsNowTitle,
        children: props.children
    });
};
// Exported Here for use in order to allow builder children while keeping the Layout Component in tact for other pages
var BaseLayoutWithChildren = (0,builder_react_es5/* withChildren */.u7)(Layout/* default */.Z) // Overall HTML BODY & HEAD
;
var BasePageTemplateWithChildren = (0,builder_react_es5/* withChildren */.u7)(BasePageTemplate) // Layout extended for Builder & Children
;
/* harmony default export */ var BaseLayoutTemplate = ((/* unused pure expression or super */ null && (BasePageTemplate)));

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.mjs
var fontawesome_svg_core = __webpack_require__(23636);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
// EXTERNAL MODULE: ./src/components/Navbar.tsx
var Navbar = __webpack_require__(97134);
// EXTERNAL MODULE: ./src/components/Footer.tsx + 2 modules
var Footer = __webpack_require__(59354);
// EXTERNAL MODULE: ./src/components/PreviewAlert.tsx
var PreviewAlert = __webpack_require__(78915);
;// CONCATENATED MODULE: ./src/components/Builder/components/cities/CitiesLayout.tsx












fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false // (https://fontawesome.com/docs/web/use-with/react/use-with)
;
var PHONE_NUMBER = "8558005629";
var CitiesLayout = function(param) {
    var children = param.children, _showGetQuote = param.showGetQuote, showGetQuote = _showGetQuote === void 0 ? true : _showGetQuote, title = param.title, _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? PHONE_NUMBER : _phoneNumber, _phoneNumberTxt = param.phoneNumberTxt, phoneNumberTxt = _phoneNumberTxt === void 0 ? (0,string_utils/* formatPhoneNumber */.u)(phoneNumber) : _phoneNumberTxt, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _preview = param.preview, preview = _preview === void 0 ? false : _preview, _description = param.description, description = _description === void 0 ? "" : _description, _robots = param.robots, robots = _robots === void 0 ? "index, follow" : _robots, ogImage = param.ogImage;
    var router = (0,next_router.useRouter)();
    var slug = (0,es/* pipe */.zGw)(util/* removeQueryString */.wK, util/* ensureEndsWithSlash */.Fd)(router.asPath);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: "/nubrakes-icon@192x192.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/img/safari-pinned-tab.svg",
                        color: "#ff4400"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/manifest.json"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "business.business"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: ogImage !== null && ogImage !== void 0 ? ogImage : "/img/new_tech_2.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msvalidate.01",
                        content: "A92E5C3F3CD0F7D6AB9BA88C995E1CD4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "qu0y9ps1iuqrt526ivxlvnrnor5dkg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://nubrakes.com".concat(slug)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: robots
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar */.wp, {
                phoneNumber: phoneNumber,
                phoneNumberTxt: phoneNumberTxt
            }),
            preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewAlert/* PreviewAlert */.n, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            showGetQuote && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUsNowBar/* CallUsNowBar */.y, {
                title: "Schedule A Brake Repair Or Get a Quote Now.",
                phoneNumber: PHONE_NUMBER
            }),
            showFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                phoneNumber: phoneNumber
            })
        ]
    });
};
/* harmony default export */ var cities_CitiesLayout = (CitiesLayout);

;// CONCATENATED MODULE: ./src/components/Builder/templates/CityPageLayoutTemplate.tsx




var CityPageTemplate = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CityPageLayoutWithChildren, {
        description: props.description,
        robots: props.robots,
        showGetQuote: props.showGetQuote,
        showFooter: props.showFooter,
        title: props.title,
        ogImage: props.ogImage,
        phoneNumber: props.phoneNumber,
        children: props.children
    });
};
var CityPageLayoutWithChildren = (0,builder_react_es5/* withChildren */.u7)(cities_CitiesLayout);
var CityPageLayoutTemplateWithChildren = (0,builder_react_es5/* withChildren */.u7)(CityPageTemplate);
/* harmony default export */ var CityPageLayoutTemplate = ((/* unused pure expression or super */ null && (CityPageTemplate)));

// EXTERNAL MODULE: ./src/components/Builder/templates/SEMLayoutTemplate.tsx
var SEMLayoutTemplate = __webpack_require__(66612);
;// CONCATENATED MODULE: ./src/components/Builder/registration/LayoutRegistration.tsx




// Base Builder Page Layout Template
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BasePageTemplateWithChildren, {
    name: "Base Page Layout",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Page Title Here... - NuBrakes Mobile Brake Repair"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "Default Meta Description..."
        },
        {
            name: "robots",
            type: "string",
            defaultValue: "index, follow",
            enum: [
                "noindex, nofollow",
                "index, follow",
                "index, nofollow",
                "noindex, follow",
                "nofollow, noimageindex",
                "follow, noimageindex", 
            ],
            helperText: "Robots will not index and nofollow by default. You must change to Index, follow for full search engine visibility."
        },
        {
            name: "showGetQuote",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showFooter",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showNavBar",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "ogImage",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/img/nubrakes-og-holder.png"
        },
        {
            name: "phoneNumber",
            type: "string",
            defaultValue: "8558005629"
        },
        {
            name: "footerDisclaimer",
            type: "richText"
        },
        {
            name: "locale",
            type: "string",
            defaultValue: "en",
            enum: [
                "en",
                "es"
            ]
        },
        {
            name: "callUsNowTitle",
            type: "string",
            helperText: "Optional. Overrides the default Call Us bar title for the selected locale."
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(CityPageLayoutTemplateWithChildren, {
    name: "City Page Layout",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Page Title Here... - NuBrakes Mobile Brake Repair"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "Default Meta Description..."
        },
        {
            name: "robots",
            type: "string",
            defaultValue: "index, follow",
            enum: [
                "noindex, nofollow",
                "index, follow",
                "index, nofollow",
                "noindex, follow",
                "nofollow, noimageindex",
                "follow, noimageindex", 
            ],
            helperText: "Robots will not index and nofollow by default. You must change to Index, follow for full search engine visibility."
        },
        {
            name: "showGetQuote",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showFooter",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "ogImage",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/img/nubrakes-og-holder.png"
        },
        {
            name: "phoneNumber",
            type: "string",
            defaultValue: "8558005629"
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(SEMLayoutTemplate/* SEMPageTemplateWithChildren */.cZ, {
    name: "SEM Page Layout",
    inputs: [
        {
            name: "locale",
            type: "string",
            defaultValue: "en",
            enum: [
                "en",
                "es"
            ]
        },
        {
            name: "callUsNowTitle",
            type: "string",
            helperText: "Optional. Overrides the bar at the bottom (Call Us)."
        },
        {
            name: "robots",
            type: "string",
            defaultValue: "noindex, nofollow",
            enum: [
                "noindex, nofollow",
                "index, follow",
                "index, nofollow",
                "noindex, follow",
                "nofollow, noimageindex",
                "follow, noimageindex", 
            ],
            helperText: "Robots will not index and nofollow by default. You must change to Index, follow for full search engine visibility."
        },
        {
            name: "showGetQuote",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showFooter",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showDefaultHeader",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showCityReviews",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "formName",
            type: "string",
            defaultValue: "semScheduleServiceForm",
            helperText: "Default is semScheduleServiceForm"
        },
        {
            name: "ogImage",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/img/nubrakes-og-holder.png"
        }, 
    ]
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/affirm.svg
/* harmony default export */ var affirm = ({"src":"/_next/static/media/affirm.64621d51.svg","height":171,"width":429});
;// CONCATENATED MODULE: ./public/img/klarna.svg
/* harmony default export */ var klarna = ({"src":"/_next/static/media/klarna.f6ca3dc0.svg","height":25,"width":45});
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/SEMPage/StarsAndRatings.tsx
var StarsAndRatings = __webpack_require__(39925);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./src/hooks/useSource.tsx
var useSource = __webpack_require__(9326);
// EXTERNAL MODULE: ./src/util/form-util.tsx
var form_util = __webpack_require__(19090);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/hooks/useFormAnalytics.tsx
var useFormAnalytics = __webpack_require__(55679);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/VehicleInfoFormSection.tsx + 1 modules
var VehicleInfoFormSection = __webpack_require__(94610);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormVariation.tsx
var NoEmailScheduleServiceFormVariation = __webpack_require__(89993);
// EXTERNAL MODULE: ./src/pages/_app.tsx
var _app = __webpack_require__(12957);
// EXTERNAL MODULE: ./src/hooks/useTestingForms.tsx
var useTestingForms = __webpack_require__(20892);
;// CONCATENATED MODULE: ./src/components/Builder/components/WizardLinkOut.tsx
















var WizardVariation = function(param) {
    var initialValues = param.initialValues, formPages = param.formPages, title = param.title, subtitle = param.subtitle, linkTarget = param.linkTarget, buttonText = param.buttonText, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var ref = (0,react.useState)(0), page = ref[0];
    var activePage = formPages[page].element;
    var length = formPages.length;
    var validationSchema = formPages[page].validationSchema;
    var defaultTitle = locale === "es" ? "Obt\xe9n una cotizaci\xf3n gratis" : "Get A Free Quote Now";
    var defaultSubtitle = locale === "es" ? "Nuestros expertos te enviar\xe1n una cotizaci\xf3n en menos de 5 minutos." : "Our repair experts will send you a quote in under 5 minutes.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-left text-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-lg md:text-xl",
                        children: title !== null && title !== void 0 ? title : defaultTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: subtitle !== null && subtitle !== void 0 ? subtitle : defaultSubtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: initialValues,
                enableReinitialize: false,
                validationSchema: validationSchema,
                onSubmit: function() {
                    console.log("submitted");
                },
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerForm, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        activePage: activePage,
                        page: page,
                        length: length,
                        buttonText: buttonText,
                        linkTarget: linkTarget,
                        locale: locale
                    }));
                }
            })
        ]
    });
};
var InnerForm = function(props) {
    var values = props.values, isValid = props.isValid, activePage = props.activePage, linkTarget = props.linkTarget, setFieldValue = props.setFieldValue, buttonText = props.buttonText, _locale = props.locale, locale = _locale === void 0 ? "en" : _locale;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    var variation = (0,useTestingForms/* useTestingForms */.d)().variation;
    (0,useFormAnalytics/* useFormAnalytics */.X)(values);
    var ymmValues = {
        vehicleYear: values === null || values === void 0 ? void 0 : values.vehicleYear,
        vehicleMake: values === null || values === void 0 ? void 0 : values.make,
        vehicleModel: values === null || values === void 0 ? void 0 : values.model
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
        name: "scheduleServiceWizard",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                type: "hidden",
                name: "form-name",
                value: "scheduleServiceWizard"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                type: "hidden",
                name: "email"
            }),
            /*#__PURE__*/ react.createElement(activePage, props),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                    disabled: !isValid,
                    className: "w-full py-2",
                    onClick: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                            var linkParams;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                e.preventDefault() // Don't let the form submit this is a link out
                                ;
                                setFieldValue("referrerSource", document.referrer, false);
                                // Record GA Event
                                if (window["dataLayer"] && window["location"]) {
                                    window["dataLayer"].push({
                                        event: "nextClicked"
                                    });
                                    linkParams = (0,_object_spread/* default */.Z)({}, query, ymmValues);
                                    if (variation) {
                                        linkParams.variation = variation;
                                    }
                                    window["location"].assign((0,util/* serializeLinkWithParams */.xN)("https://".concat(_app.CUSTOMER_WEBAPP_URL, "/").concat(linkTarget), linkParams));
                                }
                                return [
                                    2
                                ];
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    children: buttonText !== null && buttonText !== void 0 ? buttonText : locale === "es" ? "Siguiente" : "Next"
                })
            })
        ]
    });
};
var NoEmailScheduleServiceFormMultiStepLinkOut = function(param) {
    var _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? NoEmailScheduleServiceFormVariation/* twDefaultInitialWizardFormValues */.o : _initialValues, linkTarget = param.linkTarget, buttonText = param.buttonText, subtitle = param.subtitle, title = param.title, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var source = (0,useSource/* useSource */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WizardVariation, {
        title: title,
        linkTarget: linkTarget,
        buttonText: buttonText,
        subtitle: subtitle,
        locale: locale,
        initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues), {
            source: source
        }),
        formPages: [
            {
                element: VehicleInfoFormSection/* default */.ZP,
                validationSchema: VehicleInfoFormSection/* twVehicleInfoValidationSchema */.fb
            }, 
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Forms/InlineLinkoutForm.tsx








var twDefaultInitialWizardFormValues = {
    "form-name": "scheduleServiceWizard",
    fullName: "",
    email: (0,form_util/* generateFakeEmail */.W)(null),
    extraInfo: "",
    vehicleYear: "",
    phoneNumber: "",
    zip: "",
    hearAboutUs: "",
    make: "",
    model: "",
    symptoms: "",
    referredById: "",
    source: "",
    serviceUrgency: "",
    referrerSource: ""
};
var InlineLinkOutForm = function(param) {
    var _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? twDefaultInitialWizardFormValues : _initialValues, subtitle = param.subtitle, linkTarget = param.linkTarget, buttonText = param.buttonText;
    var source = (0,useSource/* useSource */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WizardVariation, {
        linkTarget: linkTarget,
        buttonText: buttonText,
        subtitle: subtitle,
        initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues), {
            source: source
        }),
        formPages: [
            {
                element: VehicleInfoFormSection/* VehicleInfoFormSectionInline */.dq,
                validationSchema: VehicleInfoFormSection/* twVehicleInfoValidationSchema */.fb
            }, 
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Builder/components/HeroKlarnaAffirmInline.tsx



















var KlarnaAffirmHeaderInline = function(param) {
    var title = param.title, rating = param.rating, reviewCount = param.reviewCount, headerTitle = param.headerTitle, _showDynamicTitle = param.showDynamicTitle, showDynamicTitle = _showDynamicTitle === void 0 ? false : _showDynamicTitle, isLinkForm = param.isLinkForm, buttonText = param.buttonText, linkTarget = param.linkTarget;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    // TODO refactor the data here
    var city = (0,es/* propOr */.Uth)("", "city", query);
    var type = (0,es/* propOr */.Uth)("", "type", query);
    var make = (0,es/* propOr */.Uth)("", "make", query);
    var content = (0,es/* propOr */.Uth)("", "utm_content", query);
    content = (0,SEMLayoutTemplate/* setContentWithFallbacks */.ZE)(type, content);
    var formalCity = city ? dist_es2015/* capitalCase */.I(city) : "";
    var phoneNumber = city && CityPhoneNumberData/* CityPhoneNumberData */.L[city] ? CityPhoneNumberData/* CityPhoneNumberData */.L[city].phoneNumber : CityPhoneNumberData/* CityPhoneNumberData.default.phoneNumber */.L["default"].phoneNumber;
    var phoneNumberTxt = (0,string_utils/* formatPhoneNumber */.u)(phoneNumber);
    var dynamicTitle = (0,getTitleFromUTMS/* getTitleFromUTMS */.u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "flex relativepb-0 sm:pb-4 pt-0 sm:pt-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "flex text-center z-10 w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4 mb-6 flex self-end flex-col w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        showDynamicTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "mb-0 mt-1 text-3xl lg:text-4xl leading-none title-wizard px-0 sm:px-8 md:px-16",
                                            children: dynamicTitle
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "mb-1 sm:mb-0 mt-1 text-2xl sm:text-3xl md:text-3xl lg:text-4xl leading-none title-wizard px-0 sm:px-8 md:px-16",
                                            children: title
                                        }),
                                        headerTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "py-2 text-gray-500 text-sm sm:text-base md:text-xl mb-2 pb-1 md:mb-2 mt-0 px-8 sm:px-4 leading-tight sub-title-wizard",
                                            children: headerTitle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-gray-100 py-4 border-gray-200 border",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineLinkOutForm, {
                                        initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA), {
                                            "form-name": "getQuoteScheduleService"
                                        }),
                                        subtitle: "",
                                        isLinkForm: isLinkForm,
                                        buttonText: buttonText,
                                        linkTarget: linkTarget
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-2 md:grid-cols-4 gap-3 pt-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bg-gray-100 px-1 py-2 border border-gray-200 md:col-start-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings/* StarsAndRatings */.G, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "leading-4",
                                            children: "Over ".concat(reviewCount, " 5 star reviews")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        pathname: "/financing",
                                        query: query
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "bg-gray-100 p-2 border-gray-200 cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid grid-cols-2 gap-1 mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: affirm,
                                                            width: 50,
                                                            height: 20,
                                                            alt: "Affirm Logo"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: klarna,
                                                            width: 50,
                                                            alt: "Klarna Logo"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "leading-4",
                                                    children: "Interest free payment plans"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./public/img/nubrakes-van-house-800-num.webp
/* harmony default export */ var nubrakes_van_house_800_num = ({"src":"/_next/static/media/nubrakes-van-house-800-num.2125988b.webp","height":571,"width":1003,"blurDataURL":"data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAADQAQCdASoIAAUAAkA4JYwCdAD0QV+DYAD+0ofd8mz/LL5IBfyp75lKPuQyt494efZAkz22+QS8wGBUZSGuP1AALsYAAA==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./public/img/vioc-logo.png
var vioc_logo = __webpack_require__(85604);
;// CONCATENATED MODULE: ./src/components/Builder/components/HomeScheduleServiceHeaderForm.tsx















var HomeScheduleServiceFormHeader = function(param) {
    var title = param.title, rating = param.rating, reviewCount = param.reviewCount, subheading = param.subheading, children = param.children, ratingsText = param.ratingsText, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale, showGradientOverlay = param.showGradientOverlay, bgImage = param.bgImage, useDynamicTitle = param.useDynamicTitle, _showVideo = param.showVideo, showVideo = _showVideo === void 0 ? false : _showVideo, video = param.video, _viocVariant = param.viocVariant, viocVariant = _viocVariant === void 0 ? false : _viocVariant;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    var city = (0,es/* propOr */.Uth)("", "city", query);
    var type = (0,es/* propOr */.Uth)("", "type", query);
    var make = (0,es/* propOr */.Uth)("", "make", query);
    var content = (0,es/* propOr */.Uth)("", "utm_content", query);
    content = (0,SEMLayoutTemplate/* setContentWithFallbacks */.ZE)(type, content);
    var formalCity = city ? dist_es2015/* capitalCase */.I(city) : "";
    var phoneNumber = city && CityPhoneNumberData/* CityPhoneNumberData */.L[city] ? CityPhoneNumberData/* CityPhoneNumberData */.L[city].phoneNumber : CityPhoneNumberData/* CityPhoneNumberData.default.phoneNumber */.L["default"].phoneNumber;
    var phoneNumberTxt = (0,string_utils/* formatPhoneNumber */.u)(phoneNumber);
    var dynamicTitle = (0,getTitleFromUTMS/* getTitleFromUTMS */.u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    var resolvedRatingsText = ratingsText !== null && ratingsText !== void 0 ? ratingsText : locale === "es" ? "clientes de reparaci\xf3n de frenos" : "brake repair customers";
    var ratingsPrefix = locale === "es" ? "NuBrakes tiene una calificaci\xf3n de ".concat(rating, "/5 por ") : "NuBrakes is rated ".concat(rating, "/5 by ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "relative overflow-hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        zIndex: -100,
                        top: 0,
                        left: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-8 flex flex-col justify-center align-center w-full h-full min-h-[60vh] relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: bgImage !== null && bgImage !== void 0 ? bgImage : nubrakes_van_house_800_num,
                                layout: "fill",
                                objectFit: "cover",
                                objectPosition: "bottom center",
                                priority: true,
                                alt: "NuBrakes Mobile Repair"
                            }),
                            showGradientOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    backgroundColor: "rgba(0,0,0,.75)",
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    zIndex: 1,
                                    top: 0,
                                    left: 0
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    className: "text-center z-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid lg:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center max-w-xl flex flex-col ".concat(showVideo ? "lg:col-span-2 items-center justify-self-center" : "col-span-1 justify-center", " ").concat(viocVariant ? "" : "lg:text-left"),
                                children: [
                                    !!viocVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-24 h-24",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: vioc_logo/* default */.Z,
                                                objectPosition: "bottom center",
                                                height: 120,
                                                width: 140,
                                                priority: true,
                                                alt: "NuBrakes Mobile Repair Header Image"
                                            })
                                        })
                                    }),
                                    useDynamicTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-2xl sm:text-2xl md:text-4xl text-white sm:mb-0",
                                        children: dynamicTitle
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-2xl sm:text-2xl md:text-4xl text-white sm:mb-0 px-2",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            fontSize: 18,
                                            marginBottom: 10
                                        },
                                        className: "subheading text-white leading-tight sm:leading-normal text-sm pb-0 ml-2",
                                        children: subheading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-auto lg:inline-block hidden p-3 text-center ".concat(viocVariant ? "" : "mr-auto"),
                                        style: {
                                            backgroundColor: "rgba(0, 0, 0, 0.69)",
                                            borderRadius: 6
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings/* StarsAndRatings */.G, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: {
                                                    color: "#cbd0d3",
                                                    lineHeight: 1
                                                },
                                                children: [
                                                    ratingsPrefix,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: {
                                                            pathname: "/reviews/",
                                                            query: query
                                                        },
                                                        prefetch: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            style: {
                                                                color: "#cbd0d3",
                                                                textDecoration: "underline"
                                                            },
                                                            children: "".concat(reviewCount)
                                                        })
                                                    }),
                                                    " ".concat(resolvedRatingsText)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-[calc(100%-1.5rem)] pb-[62%] mt-6 hidden lg:flex self-center relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute top-0 left-0 right-0 bottom-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        className: "w-full h-full",
                                        src: video,
                                        title: "YouTube video player",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-0 md:mt-6 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            backgroundColor: "white"
                                        },
                                        className: "flex flex-col p-6 lg:mt-0 text-left",
                                        children: children
                                    }),
                                    showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full pb-[52%] flex lg:hidden justify-center mt-6 relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute top-0 left-0 right-0 bottom-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                className: "w-full h-full",
                                                src: video,
                                                title: "YouTube video player",
                                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-5 block lg:hidden text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                backgroundColor: "rgba(0, 0, 0, 0.69)",
                                                borderRadius: 6
                                            },
                                            className: "block px-3 py-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings/* StarsAndRatings */.G, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    style: {
                                                        color: "#cbd0d3",
                                                        lineHeight: 1
                                                    },
                                                    children: [
                                                        ratingsPrefix,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: {
                                                                pathname: "/reviews/",
                                                                query: query
                                                            },
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                style: {
                                                                    color: "#cbd0d3",
                                                                    textDecoration: "underline"
                                                                },
                                                                children: "".concat(reviewCount, " ").concat(resolvedRatingsText)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/SEMPage/HeaderSection.tsx
var HeaderSection = __webpack_require__(79610);
// EXTERNAL MODULE: ./public/img/nubrakes-brake-repair-header.jpeg
var nubrakes_brake_repair_header = __webpack_require__(12535);
// EXTERNAL MODULE: ./src/components/BgImage.tsx
var BgImage = __webpack_require__(63549);
;// CONCATENATED MODULE: ./src/components/Builder/components/ContentHeader.tsx




var ContentHeader = function(param) {
    var title = param.title, description = param.description, bgImageOverride = param.bgImageOverride;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "py-0 content-header",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BgImage/* BgImage */.D, {
            src: bgImageOverride !== null && bgImageOverride !== void 0 ? bgImageOverride : nubrakes_brake_repair_header/* default */.Z,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "title text-white px-4 sm:px-0",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-white description",
                        children: description
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/LandingPage/TitleSection.tsx + 1 modules
var TitleSection = __webpack_require__(32158);
// EXTERNAL MODULE: ./src/components/Builder/components/HeroInline.tsx + 1 modules
var HeroInline = __webpack_require__(70397);
;// CONCATENATED MODULE: ./src/components/Builder/registration/HeroRegistration.tsx










var BASE_WEB_APP_URL = "get-a-quote/services";
var BuilderKlarnaAffirmInlineHeader = function(param) {
    var _builderState = param.builderState, _state = _builderState.state, rating = _state.rating, reviewCount = _state.reviewCount, showImage = param.showImage, showGradient = param.showGradient, image = param.image, title = param.title, subtitle = param.subtitle, subheading = param.subheading, headerTitle = param.headerTitle, eventVariationLabel = param.eventVariationLabel, showDynamicTitle = param.showDynamicTitle, ratingsText = param.ratingsText, isLinkForm = param.isLinkForm, linkTarget = param.linkTarget, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(KlarnaAffirmHeaderInline, {
        image: image,
        showImage: showImage,
        showGradient: showGradient,
        title: title,
        subtitle: subtitle,
        rating: rating,
        reviewCount: reviewCount,
        subheading: subheading,
        headerTitle: headerTitle,
        eventVariationLabel: eventVariationLabel,
        showDynamicTitle: showDynamicTitle,
        ratingsText: ratingsText,
        isLinkForm: isLinkForm,
        linkTarget: linkTarget,
        buttonText: buttonText
    });
};
var BuilderInlineHeader = function(param) {
    var _builderState = param.builderState, _state = _builderState.state, rating = _state.rating, reviewCount = _state.reviewCount, showImage = param.showImage, showGradient = param.showGradient, image = param.image, showVideo = param.showVideo, video = param.video, title = param.title, subtitle = param.subtitle, subheading = param.subheading, headerTitle = param.headerTitle, eventVariationLabel = param.eventVariationLabel, showDynamicTitle = param.showDynamicTitle, ratingsText = param.ratingsText, isLinkForm = param.isLinkForm, linkTarget = param.linkTarget, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroInline/* HomeScheduleServiceFormHeaderInline */.L, {
        image: image,
        showImage: showImage,
        showGradient: showGradient,
        showVideo: showVideo,
        video: video,
        title: title,
        subtitle: subtitle,
        rating: rating,
        reviewCount: reviewCount,
        subheading: subheading,
        headerTitle: headerTitle,
        eventVariationLabel: eventVariationLabel,
        showDynamicTitle: showDynamicTitle,
        ratingsText: ratingsText,
        isLinkForm: isLinkForm,
        linkTarget: linkTarget,
        buttonText: buttonText
    });
};
// Inline New Inline Form Based Hero
// Inline New Inline Form Based Hero
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderInlineHeader, {
    name: "Hero Inline Form",
    inputs: [
        {
            name: "image",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            helperText: "1280w x 768h works best"
        },
        {
            name: "video",
            type: "text",
            defaultValue: "",
            helperText: "https://www.youtube.com/embed"
        },
        {
            name: "title",
            type: "string",
            defaultValue: "Get a Free Quote Now",
            helperText: "h1 Quote Form Title"
        },
        {
            name: "showImage",
            type: "boolean",
            defaultValue: "true"
        },
        {
            name: "showVideo",
            type: "boolean",
            defaultValue: "false"
        },
        {
            name: "showDynamicTitle",
            type: "boolean",
            defaultValue: "false",
            helperText: "This will hide the manually entered title above"
        },
        {
            name: "showGradient",
            type: "boolean",
            defaultValue: "true"
        },
        {
            name: "headerTitle",
            type: "string",
            defaultValue: "We save our customers 40% on average over shop prices — book affordable repairs without leaving your home."
        },
        {
            name: "subtitle",
            type: "string",
            defaultValue: "Our repair experts will send you a quote in under 5 minutes.",
            helperText: "Text under inline form"
        },
        {
            name: "ratingsText",
            type: "string",
            defaultValue: "brake repair customers",
            helperText: "Text after review count"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Get A Free Quote"
        },
        {
            name: "eventVariationLabel",
            type: "string",
            helperText: "Control/Test Variant Label"
        },
        {
            name: "isLinkForm",
            type: "boolean",
            defaultValue: false,
            helperText: "Links to Customer Web App When On",
            onChange: function(options) {
                if (options.get("isLinkForm") === true) {
                    options.set("linkTarget", BASE_WEB_APP_URL);
                }
            }
        },
        {
            name: "linkTarget",
            type: "string",
            showIf: function(options) {
                return options.get("isLinkForm");
            },
            defaultValue: BASE_WEB_APP_URL,
            helperText: "Customer Web App Link Pathname"
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderKlarnaAffirmInlineHeader, {
    name: "HeroInlineKlarnaAffirm",
    inputs: [
        {
            name: "image",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            helperText: "1280w x 768h works best"
        },
        {
            name: "title",
            type: "string",
            defaultValue: "Get a Free Quote Now",
            helperText: "h1 Quote Form Title"
        },
        {
            name: "showImage",
            type: "boolean",
            defaultValue: "true"
        },
        {
            name: "showDynamicTitle",
            type: "boolean",
            defaultValue: "false",
            helperText: "This will hide the manually entered title above"
        },
        {
            name: "showGradient",
            type: "boolean",
            defaultValue: "true"
        },
        {
            name: "headerTitle",
            type: "string",
            defaultValue: "We save our customers 40% on average over shop prices — book affordable repairs without leaving your home."
        },
        {
            name: "subtitle",
            type: "string",
            defaultValue: "Our repair experts will send you a quote in under 5 minutes.",
            helperText: "Text under inline form"
        },
        {
            name: "ratingsText",
            type: "string",
            defaultValue: "brake repair customers",
            helperText: "Text after review count"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Get A Free Quote"
        },
        {
            name: "eventVariationLabel",
            type: "string",
            helperText: "Control/Test Variant Label"
        },
        {
            name: "isLinkForm",
            type: "boolean",
            defaultValue: false,
            helperText: "Links to Customer Web App When On",
            onChange: function(options) {
                if (options.get("isLinkForm") === true) {
                    options.set("linkTarget", BASE_WEB_APP_URL);
                }
            }
        },
        {
            name: "linkTarget",
            type: "string",
            showIf: function(options) {
                return options.get("isLinkForm");
            },
            defaultValue: BASE_WEB_APP_URL,
            helperText: "Customer Web App Link Pathname"
        }, 
    ]
});
var BuilderScheduleServiceFormHeader = function(props) {
    var _builderState = props.builderState, _state = _builderState.state, rating = _state.rating, reviewCount = _state.reviewCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeScheduleServiceFormHeader, (0,_object_spread/* default */.Z)({
        title: props.title,
        subheading: props.subheading,
        rating: rating,
        reviewCount: reviewCount,
        ratingsText: props.ratingsText,
        locale: props.locale,
        showGradientOverlay: props.showGradientOverlay,
        bgImage: props.bgImage,
        showVideo: props.showVideo,
        video: props.video
    }, props));
};
var BuilderScheduleServiceFormHeaderWithChildren = (0,builder_react_es5/* withChildren */.u7)(BuilderScheduleServiceFormHeader);
// Hero that Takes Children in Quote Area (Wizard / Contact Us)
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderScheduleServiceFormHeaderWithChildren, {
    name: "Header Insert Quote",
    inputs: [
        {
            name: "locale",
            type: "string",
            defaultValue: "en",
            enum: [
                "en",
                "es"
            ]
        },
        {
            name: "title",
            type: "string",
            defaultValue: "Get A Free Quote Now"
        },
        {
            name: "subheading",
            type: "string",
            defaultValue: "Our repair experts will send you a quote in under 5 minutes."
        },
        {
            name: "ratingsText",
            type: "string",
            defaultValue: "brake repair customers"
        },
        {
            name: "showGradientOverlay",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "bgImage",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            helperText: "1280w x 768h works best"
        },
        {
            name: "showVideo",
            type: "boolean",
            defaultValue: "false"
        },
        {
            name: "video",
            type: "text",
            defaultValue: "",
            helperText: "https://www.youtube.com/"
        },
        {
            name: "eventVariationLabel",
            type: "string",
            defaultValue: "Hero Control Variant",
            helperText: "What should the variant be labeled?"
        },
        {
            name: "useDynamicTitle",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "viocVariant",
            type: "boolean",
            defaultValue: false
        }, 
    ]
});
var BuilderHeaderSection = function(param) {
    var _builderState = param.builderState, _state = _builderState.state, rating = _state.rating, reviewCount = _state.reviewCount, title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection/* default */.Z, {
        title: title,
        subtitle: subtitle,
        rating: rating,
        reviewCount: reviewCount
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderHeaderSection, {
    name: "Header Section",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Title Text Here..."
        },
        {
            name: "subtitle",
            type: "string",
            defaultValue: "We save our customers 40% on average over shop prices — book affordable repairs without leaving your home."
        }, 
    ]
});
// Basic Image Background Hero with Title Overlay (e.g. Warranty)
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(ContentHeader, {
    name: "Content Header",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Page Title"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "Page Description"
        },
        {
            name: "bgImageOverride",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ]
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(TitleSection/* BuilderTitleSection */.C, {
    name: "Title Section",
    inputs: [
        {
            name: "image",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ]
        },
        {
            name: "subheading",
            type: "string",
            defaultValue: "Mobile Auto Repair Built for You"
        },
        {
            name: "title",
            type: "string",
            defaultValue: "NuBrakes Mobile Repair"
        },
        {
            name: "phoneNumberTxt",
            type: "string"
        },
        {
            name: "phoneNumber",
            type: "string"
        },
        {
            name: "callToActionButtonText",
            type: "string",
            defaultValue: "Get A Quote"
        },
        {
            name: "showImage",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showRatings",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showOverlay",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "buttonColor",
            type: "color",
            defaultValue: "#ffc107"
        }, 
    ],
    defaultStyles: {
        backgroundColor: "#000",
        display: "flex",
        color: "#fff",
        padding: "1rem"
    }
});

// EXTERNAL MODULE: ./src/components/Builder/components/Wizard.tsx
var Wizard = __webpack_require__(34638);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailPersonalInfoFormSection.tsx + 1 modules
var NoEmailPersonalInfoFormSection = __webpack_require__(50809);
// EXTERNAL MODULE: ./src/components/Builder/components/WizardInline.tsx
var WizardInline = __webpack_require__(40084);
;// CONCATENATED MODULE: ./src/components/Builder/components/HeroForm.tsx










var HeroForm = function(param) {
    var _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA : _initialValues, _title = param.title, title = _title === void 0 ? "Get A Free Quote Now" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "Our repair experts will send you a quote in under 5 minutes." : _subtitle;
    var source = (0,useSource/* useSource */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard/* Wizard */.e, {
        title: title,
        subtitle: subtitle,
        initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues), {
            source: source
        }),
        onSubmit: NoEmailScheduleServiceFormMultiStep/* scheduleServiceFormMultiStepSubmit */.dR,
        formPages: [
            {
                element: VehicleInfoFormSection/* default */.ZP,
                validationSchema: VehicleInfoFormSection/* twVehicleInfoValidationSchema */.fb
            },
            {
                element: NoEmailPersonalInfoFormSection/* default */.ZP,
                validationSchema: NoEmailPersonalInfoFormSection/* PersonalInfoValidationSchema */.xG
            }, 
        ]
    });
};
var HeroFormInline = function(param) {
    var _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA : _initialValues, isLinkForm = param.isLinkForm, linkTarget = param.linkTarget, buttonText = param.buttonText, inlineStack = param.inlineStack, title = param.title, subtitle = param.subtitle;
    var source = (0,useSource/* useSource */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-center",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-center leading-none mb-3",
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WizardInline/* WizardInline */.l, {
                isLinkForm: isLinkForm,
                linkTarget: linkTarget,
                buttonText: buttonText,
                initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues), {
                    source: source
                }),
                onSubmit: NoEmailScheduleServiceFormMultiStep/* scheduleServiceFormMultiStepSubmit */.dR,
                formPages: [
                    {
                        element: inlineStack ? VehicleInfoFormSection/* VehicleInfoFormSectionInlineStack */.iE : VehicleInfoFormSection/* VehicleInfoFormSectionInline */.dq,
                        validationSchema: VehicleInfoFormSection/* twVehicleInfoValidationSchema */.fb
                    },
                    {
                        element: NoEmailPersonalInfoFormSection/* NoEmailPersonalInfoFormSectionInline */.GO,
                        validationSchema: NoEmailPersonalInfoFormSection/* PersonalInfoValidationSchema */.xG
                    }, 
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Forms/ContactUsForm.tsx
var ContactUsForm = __webpack_require__(12049);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/Fields/CustomTextField.tsx
var CustomTextField = __webpack_require__(12640);
// EXTERNAL MODULE: ./src/util/quote-form-utils.ts + 2 modules
var quote_form_utils = __webpack_require__(53829);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faSpinner.js
var faSpinner = __webpack_require__(92332);
// EXTERNAL MODULE: ./src/components/clients/new-backend.client.ts
var new_backend_client = __webpack_require__(36826);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 14 modules
var lib = __webpack_require__(59397);
// EXTERNAL MODULE: ./src/components/Fields/CustomSelectField.tsx
var CustomSelectField = __webpack_require__(51559);
;// CONCATENATED MODULE: ./src/components/Forms/FleetContactUsForm.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      mutation fleetContactUs($contactUsInput: ContactUsInput!) {\n        fleetContactUs(contactUsInput: $contactUsInput)\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var formSchema = yup_es/* object */.Ry().shape({
    firstName: yup_es/* string */.Z_().required("Required"),
    lastName: yup_es/* string */.Z_().required("Required"),
    businessName: yup_es/* string */.Z_().required("Required"),
    numberOfVehicles: yup_es/* string */.Z_().required("Required"),
    email: yup_es/* string */.Z_().email("Email address is not valid").required("Required"),
    // https://stackoverflow.com/a/16702965
    phoneNumber: yup_es/* string */.Z_().matches(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/, "Phone number is not valid").required("Required"),
    message: yup_es/* string */.Z_().required("Required")
});
function submitToBackend(values) {
    return _submitToBackend.apply(this, arguments);
}
function _submitToBackend() {
    _submitToBackend = (0,_async_to_generator/* default */.Z)(function(values) {
        var formName, rest;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formName = values["form-name"], rest = (0,_object_without_properties/* default */.Z)(values, [
                        "form-name"
                    ]);
                    return [
                        4,
                        new_backend_client/* newBackendClient.mutate */.t.mutate({
                            variables: {
                                contactUsInput: rest
                            },
                            mutation: (0,lib/* default */.ZP)(_templateObject())
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _submitToBackend.apply(this, arguments);
}
var FleetContactUsForm = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            "form-name": "contact",
            email: "",
            phoneNumber: "",
            businessName: "",
            numberOfVehicles: "",
            lastName: "",
            firstName: "",
            message: ""
        },
        validationSchema: formSchema,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    submitToBackend(values),
                                    (0,quote_form_utils/* catchAll */.km)(values)
                                ])
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                router.push("/fleet-success/").then(function() {
                                    return window.scrollTo(0, 0);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var isSubmitting = param.isSubmitting;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                name: "contactForm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                        type: "hidden",
                        name: "form-name",
                        value: "contactForm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "firstName",
                                            component: CustomTextField/* CustomTextField */.yM,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "lastName",
                                            component: CustomTextField/* CustomTextField */.yM,
                                            required: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "businessName",
                                            component: CustomTextField/* CustomTextField */.yM,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                            name: "numberOfVehicles",
                                            component: CustomSelectField/* CustomSelectField */.fw,
                                            options: [
                                                "5 - 25",
                                                "26 - 50",
                                                "51 - 100",
                                                "101 - 200",
                                                "201 - 500",
                                                "501 - 1,000",
                                                "1,001 - 5,000",
                                                "5,001+", 
                                            ],
                                            required: true,
                                            errorTextStyle: {
                                                color: "red"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                    name: "email",
                                    type: "email",
                                    component: CustomTextField/* CustomTextField */.yM,
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                    name: "phoneNumber",
                                    component: CustomTextField/* CustomTextField */.yM,
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                    name: "message",
                                    as: "textarea",
                                    component: CustomTextField/* CustomTextField */.yM,
                                    required: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        disabled: isSubmitting,
                        type: "submit",
                        children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: faSpinner/* faSpinner */.LM,
                            spin: true
                        }) : "Submit"
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Builder/registration/FormRegistration.tsx






builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(HeroForm, {
    name: "Get A Quote Wizard",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Get A Free Quote Now"
        },
        {
            name: "subtitle",
            type: "string",
            defaultValue: "Our repair experts will send you a quote in under 5 minutes."
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(HeroFormInline, {
    name: "Inline Quote Wizard",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Get A Free Quote Now"
        },
        {
            name: "subtitle",
            type: "string",
            defaultValue: "Our repair experts will send you a quote in under 5 minutes."
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Next"
        },
        {
            name: "isLinkForm",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "linkTarget",
            type: "string",
            helperText: "Customer Web App Pathname",
            defaultValue: BASE_WEB_APP_URL
        },
        {
            name: "inlineStack",
            type: "boolean",
            defaultValue: true
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(NoEmailScheduleServiceFormMultiStepLinkOut, {
    name: "Dev CWA Wizard",
    inputs: [
        {
            name: "locale",
            type: "string",
            defaultValue: "en",
            enum: [
                "en",
                "es"
            ]
        },
        {
            name: "title",
            type: "string",
            defaultValue: "Get A Free Quote Now"
        },
        {
            name: "subtitle",
            type: "string",
            defaultValue: "Our repair experts will send you a quote in under 5 minutes."
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Next"
        },
        {
            name: "linkTarget",
            type: "string",
            helperText: "Customer Web App Pathname",
            defaultValue: BASE_WEB_APP_URL
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(ContactUsForm/* ContactUsForm */.x, {
    name: "Contact Us Form"
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(FleetContactUsForm, {
    name: "Fleet Contact Us Form"
});

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
;// CONCATENATED MODULE: ./src/components/Builder/components/HowItWorksGreenCheck.tsx






var HowItWorksGreenCheck_HowItWorksGreenCheckSection = function(param) {
    var first = param.first, second = param.second, third = param.third, title = param.title, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var defaultCopy = locale === "es" ? {
        title: "\xbfPor qu\xe9 NuBrakes?",
        first: {
            title: "Vamos a ti",
            subtitle: "Nuestros t\xe9cnicos m\xf3viles ofrecen reparaciones de frenos con excelentes calificaciones en tu casa u oficina por hasta 40% menos que un taller."
        },
        second: {
            title: "Mejores precios",
            subtitle: "En promedio somos 40% m\xe1s accesibles que concesionarios y talleres, as\xed que ahorras tiempo y dinero."
        },
        third: {
            title: "Disponibilidad el mismo d\xeda",
            subtitle: "\xbfNecesitas reparar tus frenos hoy? Normalmente hay servicio el mismo d\xeda — cont\xe1ctanos para agendar."
        }
    } : {
        title: "Why NuBrakes?",
        first: {
            title: "We Come To You",
            subtitle: "Our mobile brake techs deliver top-rated brake repairs at your home or office for up to 40% less than a repair shop."
        },
        second: {
            title: "Better Prices",
            subtitle: "We're 40% more affordable on average compared to the dealerships and shops, so you'll be saving time and money."
        },
        third: {
            title: "Same-Day Availability",
            subtitle: "Need your brakes repaired today? Same-day service is typically available — contact us to schedule!"
        }
    };
    var resolvedTitle = title !== null && title !== void 0 ? title : defaultCopy.title;
    var resolvedFirst = first !== null && first !== void 0 ? first : defaultCopy.first;
    var resolvedSecond = second !== null && second !== void 0 ? second : defaultCopy.second;
    var resolvedThird = third !== null && third !== void 0 ? third : defaultCopy.third;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center mb-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: resolvedTitle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid md:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheckHowItWorks, (0,_object_spread/* default */.Z)({}, resolvedFirst)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheckHowItWorks, (0,_object_spread/* default */.Z)({}, resolvedSecond)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenCheckHowItWorks, (0,_object_spread/* default */.Z)({}, resolvedThird))
                    ]
                })
            ]
        })
    });
};
var GreenCheckHowItWorks = function(param) {
    var title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mr-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                    style: {
                        fontWeight: 100
                    },
                    size: "1x",
                    color: "#14d90d"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./src/components/Builder/components/GraySection.tsx


var GraySection = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-100 py-[5%] lg:py-4",
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Builder/components/cities/Convenient.tsx



// import Image from 'next/image'


var ConvenientAffordableSection = function(param) {
    var title = param.title, description = param.description, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-center pt-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title pt-0 sm:pt-2 text-3xl sm:text-4xl",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "description text-base mb-4 sm:mb-2",
                    dangerouslySetInnerHTML: {
                        __html: browser_default().sanitize(description)
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-3 gap-4",
                    children: children
                })
            ]
        })
    });
};
var BookFactsSection = function(param) {
    var title = param.title, description = param.description, leftColumnTitle = param.leftColumnTitle, leftColumnText = param.leftColumnText, rightColumnTitle = param.rightColumnTitle, rightColumnText = param.rightColumnText, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection, {
        className: "text-center mb-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-12 px-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "pt-5 sm:pt-0 title text-center text-2xl mt-2 w-full",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description text-center px-12 sm:px-2",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid lg:grid-cols-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:col-span-8 facts-block bg-white border-2 border-gray-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-left p-6 sm:p-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: leftColumnTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: leftColumnText
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:col-span-4 facts-block border-2 border-gray-100 bg-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FactsSideBar, {
                                sidebarTitle: rightColumnTitle,
                                sidebarSubtitle: rightColumnText,
                                children: children
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var FactsSideBar = function(param) {
    var sidebarTitle = param.sidebarTitle, sidebarSubtitle = param.sidebarSubtitle, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-6 pt-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-3 mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold leading-tight text-2xl text-black mb-0",
                        children: sidebarTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold leading-tight text-xl text-black",
                        children: sidebarSubtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center px-2",
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/Builder/components/Button.tsx








function LandingPageButton(props) {
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            pathname: "/get-quote/",
            query: query
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "w-full block sm:w-auto sm:inline -mt-6 sm:mt-0",
                style: {
                    paddingTop: 12,
                    paddingBottom: 12,
                    paddingLeft: 30,
                    paddingRight: 30,
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    backgroundColor: props.color || "#00AEEF",
                    color: props.textColor || "white"
                }
            }, props.buttonProps), {
                children: props.buttonText
            }))
        })
    });
}
var Button_Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        disabled: disabled,
        className: classnames_default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/Builder/components/IconGridSection.tsx







var IconGridSection = function(props) {
    var title = props.title, description = props.description, children = props.children, buttonText = props.buttonText, buttonColor = props.buttonColor, buttonTextColor = props.buttonTextColor;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var city = (0,es/* propOr */.Uth)("", "city", query);
    var dynamicPhoneNumber = city && CityPhoneNumberData/* CityPhoneNumberData */.L[city] ? CityPhoneNumberData/* CityPhoneNumberData */.L[city].phoneNumber : props.phoneNumber;
    var phoneNumberTxt = (0,string_utils/* formatPhoneNumber */.u)(dynamicPhoneNumber !== null && dynamicPhoneNumber !== void 0 ? dynamicPhoneNumber : props.phoneNumber);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-2 md:px-8 lg:px-24 max-w-[1260px] mx-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-0 sm:mt-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title text-2xl sm:text-3xl md:text-4xl px-12 sm:px-0",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description px-8 sm:px-2 leading-tight text-base sm:text-base pb-8",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-mt-3 sm:mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-3 gap-0 place-items-stretch bg-white shadow-xl mt-2 sm:mt-1 md:mt-0",
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-12",
                children: [
                    buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-6 mt-2 px-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton, {
                            textColor: buttonTextColor,
                            color: buttonColor,
                            buttonText: buttonText
                        })
                    }),
                    props.phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            "Or call us at ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "tel:".concat(props.phoneNumber),
                                children: phoneNumberTxt
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var IconGridItem = function(param) {
    var title = param.title, description = param.description, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full py-4 pt-8 flex flex-grow-1 flex-col h-100 text-center px-4 sm:px-6",
        style: {
            border: "1px solid #dddddd",
            borderBottom: "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Builder/components/CarBrandGrid.tsx
var CarBrandGrid = __webpack_require__(65105);
;// CONCATENATED MODULE: ./src/components/Builder/registration/GridRegistration.tsx








// TODO: needs rework of component
var BuilderHowItWorksGreenCheckSection = function(param) {
    var title = param.title, first = param.first, second = param.second, third = param.third, locale = param.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: first && second && third && /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksGreenCheck_HowItWorksGreenCheckSection, {
            locale: locale,
            title: title,
            first: (0,_object_spread/* default */.Z)({}, first[0]),
            second: (0,_object_spread/* default */.Z)({}, second[0]),
            third: (0,_object_spread/* default */.Z)({}, third[0])
        })
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderHowItWorksGreenCheckSection, {
    name: "How It Works Green Check Section",
    inputs: [
        {
            name: "locale",
            type: "string",
            defaultValue: "en",
            enum: [
                "en",
                "es"
            ]
        },
        {
            name: "title",
            type: "string",
            defaultValue: "Why NuBrakes?"
        },
        {
            name: "first",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string",
                    defaultValue: "We Come To You"
                },
                {
                    name: "subtitle",
                    type: "string",
                    defaultValue: "Our mobile brake techs deliver top-rated brake repairs at your home or office for up to 40% less than a repair shop."
                }, 
            ]
        },
        {
            name: "second",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string",
                    defaultValue: "Better Prices"
                },
                {
                    name: "subtitle",
                    type: "string",
                    defaultValue: "We're 40% more affordable on average compared to the dealerships and shops, so you'll be saving time and money."
                }, 
            ]
        },
        {
            name: "third",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string",
                    defaultValue: "Same-Day Availability"
                },
                {
                    name: "subtitle",
                    type: "string",
                    defaultValue: "Need your brakes repaired today? Same-day service is typically available — contact us to schedule!"
                }, 
            ]
        }, 
    ]
});
var IconGridItemWithChild = (0,builder_react_es5/* withChildren */.u7)(IconGridItem);
var IconGridSectionWithChildren = (0,builder_react_es5/* withChildren */.u7)(IconGridSection);
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(IconGridItemWithChild, {
    name: "Icon Text Item",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Step 1"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "Step 1 description"
        }, 
    ],
    defaultChildren: [
        {
            "@type": "@builder.io/sdk:Element",
            component: {
                name: "Text",
                options: {
                    text: "I am child text block!"
                }
            }
        }, 
    ],
    defaultStyles: {
        display: "flex"
    }
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(IconGridSectionWithChildren, {
    name: "Icon Grid Section",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "NuBrakes Mobile Repair"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "Mobile Auto Repair Built for You"
        },
        {
            name: "phoneNumber",
            type: "string"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Get A Quote"
        },
        {
            name: "buttonColor",
            type: "color",
            defaultValue: "#ffc107"
        },
        {
            name: "buttonTextColor",
            type: "color",
            defaultValue: "#ffffff"
        }, 
    ],
    defaultStyles: {
        display: "flex",
        textAlign: "center",
        paddingTop: "20px",
        paddingBottom: "20px",
        backgroundColor: "#fdfdfd"
    }
});
var ConvenientAffordableSectionWithChildren = (0,builder_react_es5/* withChildren */.u7)(ConvenientAffordableSection);
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(ConvenientAffordableSectionWithChildren, {
    name: "Simple Grid",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Convenient & Affordable"
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "<p>We offer a variety of services to fit your needs.</p>"
        }, 
    ],
    defaultStyles: {
        textAlign: "center",
        backgroundColor: "rgba(243, 244, 246,1)"
    }
});
var BuilderCarBrandGrid = function(props) {
    var _builderState = props.builderState, carContent = _builderState.state.carContent, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarBrandGrid/* CarBrandGrid */.Q, (0,_object_spread/* default */.Z)({
        title: title,
        carContent: carContent
    }, props));
};
var BuilderCarBrandGridWithChildren = (0,builder_react_es5/* withChildren */.u7)(BuilderCarBrandGrid);
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderCarBrandGridWithChildren, {
    name: "Car Brand Grid",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Skip The Brake Shop, We Offer Brake Services On Nearly Every Make & Model"
        }, 
    ],
    defaultChildren: [
        {
            "@type": "@builder.io/sdk:Element",
            component: {
                name: "Text",
                options: {
                    text: "I am child text block!"
                }
            }
        }, 
    ]
});

// EXTERNAL MODULE: ./src/components/SEMPage/ReviewsSection.tsx + 4 modules
var ReviewsSection = __webpack_require__(94014);
;// CONCATENATED MODULE: ./src/components/Builder/components/OurTechnicians.tsx




var OurTechnicians = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            className: "text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title text-4xl mb-3",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-xl",
                        dangerouslySetInnerHTML: {
                            __html: props.subtitle
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: props.children
                    })
                ]
            })
        })
    });
};
var BuilderOurTechniciansWithChildren = (0,builder_react_es5/* withChildren */.u7)(OurTechnicians);

;// CONCATENATED MODULE: ./src/components/Builder/components/CallUsNowBar.tsx



var CallUsNowBar_CallUsNowBar = function(param) {
    var _title = param.title, title = _title === void 0 ? "Schedule A Brake Repair Or Get A Quote Now." : _title, phoneNumber = param.phoneNumber, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        style: {
            backgroundColor: backgroundColor,
            paddingTop: "3%",
            paddingBottom: "3%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center hidden sm:flex flex-row items-center justify-center flex-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "m-0",
                        style: {
                            color: "white",
                            lineHeight: 1.5
                        },
                        children: title
                    }),
                    phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "bg-transparent hover:bg-white hover:text-lime text-white border-white border-4 rounded p-3 ml-5 font-semibold",
                            children: (0,string_utils/* formatPhoneNumber */.u)(phoneNumber)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sm:hidden text-center px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-white text-2xl leading-tight mb-3 mt-2 sm:mb-0 sm:mt-0",
                        children: title
                    }),
                    phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "mb-3 sm:mb-0 bg-transparent hover:bg-white hover:text-lime text-white border-white border-4 rounded p-3 font-semibold",
                            children: (0,string_utils/* formatPhoneNumber */.u)(phoneNumber)
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/index.mjs
var pro_duotone_svg_icons = __webpack_require__(21702);
;// CONCATENATED MODULE: ./src/components/Builder/components/FAIcon.tsx




// Solid Style - fas
// Regular Style - far
// Light Style - fal
// Duotone Style - fad
var faIconNameList = Object.keys(pro_duotone_svg_icons/* fad */.ZAJ).map(function(key) {
    return pro_duotone_svg_icons/* fad */.ZAJ[key].iconName;
});
var FAIcon = function(props) {
    var faIcons = Object.keys(pro_duotone_svg_icons/* fad */.ZAJ).map(function(key) {
        return pro_duotone_svg_icons/* fad */.ZAJ[key];
    });
    var icon = faIcons.filter(function(icon) {
        return icon.iconName === props.icon;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        style: {
            color: props.iconColor
        },
        icon: icon[0],
        size: props.iconSize
    });
};

// EXTERNAL MODULE: ./public/img/nubrakes-logo-no-text.svg
var nubrakes_logo_no_text = __webpack_require__(5120);
;// CONCATENATED MODULE: ./src/components/Builder/components/cities/CityNearYou.tsx








var CityNearYouSection = function(param) {
    var title = param.title, description = param.description, listOfMinorCities = param.listOfMinorCities, phoneNumberTxt = param.phoneNumberTxt, phoneNumber = param.phoneNumber, buttonText = param.buttonText, buttonColor = param.buttonColor, _builderState = param.builderState, butterCities = _builderState.state.butterCities;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: nubrakes_logo_no_text/* default */.Z,
                        alt: "NuBrakes Logo",
                        className: "mx-auto"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-4 mt-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "title mt-8",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }),
                        listOfMinorCities ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                color: "#818b92"
                            },
                            children: listOfMinorCities.split(",").join(", ")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BrakeRepairNearYouWithCities, {
                            cities: butterCities
                        })
                    ]
                }),
                phoneNumberTxt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "w-full mb-0 px-8",
                    children: [
                        "Call us at ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:".concat(phoneNumber),
                            children: phoneNumberTxt
                        }),
                        " to speak with a brake specialist or click the button below to receive a free, no-obligation quote."
                    ]
                }),
                buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-6 mb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton, {
                        color: buttonColor,
                        buttonText: buttonText
                    })
                })
            ]
        })
    });
};
var BrakeRepairNearYouWithCities = function(props) {
    var cities = props.cities;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid sm:grid-cols-2 md:grid-cols-4 gap-3 text-center sm:text-left",
                children: cities && cities.map(function(city, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            as: "/cities/".concat(city.slug, "/"),
                            href: "/cities/[slug]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "".concat(city.cityName, " Brake Repair")
                            })
                        })
                    }, index);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/CarPage/FAQSection.tsx
var FAQSection = __webpack_require__(6550);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var react_modal_lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_modal_lib);
;// CONCATENATED MODULE: ./src/components/Modal.tsx





var defaultStyle = {
    content: {
        padding: 0,
        maxWidth: "'100%'",
        margin: "0 auto",
        display: "flex",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-45%",
        transform: "translate(-50%, -50%)",
        paddingBottom: "1em"
    },
    overlay: {
        zIndex: 40,
        backgroundColor: "rgba(255, 255, 255, 0.55)"
    }
};
var NuModal = function(param) {
    var isOpen = param.isOpen, toggleModal = param.toggleModal, children = param.children, contentLabel = param.contentLabel, onRequestClose = param.onRequestClose, shouldCloseOnOverlayClick = param.shouldCloseOnOverlayClick, appCSSSelector = param.appCSSSelector, modalStyle = param.modalStyle;
    lib_default().setAppElement(appCSSSelector !== null && appCSSSelector !== void 0 ? appCSSSelector : "#__next") // default to the body (NextJS App)
    ;
    var style = (0,util/* unflatten */.Fw)(Object.assign((0,util/* flattenObj */.nO)(defaultStyle), (0,util/* flattenObj */.nO)(modalStyle)));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
        isOpen: isOpen,
        style: style,
        onRequestClose: onRequestClose,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        contentLabel: contentLabel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 relative",
                onClick: toggleModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-4 absolute right-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xl hover:cursor-pointer",
                        children: "✕"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 mb-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "w-10/12 lg:w-9/12 mx-auto text-center mb-1 leading-none",
                    children: contentLabel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "pb-4",
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(54887);
;// CONCATENATED MODULE: ./src/components/Builder/components/PromoModal.tsx






function PromoModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        mutation createPromoUser($promoUserInput: PromoUserInput!) {\n          createPromoUser(promoUserInput: $promoUserInput) {\n            phoneNumber\n            promoContent\n          }\n        }\n      "
    ]);
    PromoModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var validationSchema = yup_es/* object */.Ry().shape({
    phoneNumber: yup_es/* string */.Z_().required("Required").min(7, "Phone number is not valid").matches(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/, "Phone number is not valid")
});
var PromoModalContent = function(param) {
    var buttonText = param.buttonText, buttonHelpText = param.buttonHelpText, postSubmissionText1 = param.postSubmissionText1, postSubmissionText2 = param.postSubmissionText2, promoContent = param.promoContent;
    var ref = (0,react.useState)(false), successfulSubmit = ref[0], setSuccessfulSubmit = ref[1];
    var queryParams = query_string/* default.parse */.Z.parse(window.location.search);
    function onSubmit(values) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, formattedPhone;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        formattedPhone = values === null || values === void 0 ? void 0 : (ref = values.phoneNumber) === null || ref === void 0 ? void 0 : ref.replace(/-/g, "");
                        return [
                            4,
                            new_backend_client/* newBackendClient.mutate */.t.mutate({
                                variables: {
                                    promoUserInput: {
                                        phoneNumber: formattedPhone,
                                        promoContent: promoContent,
                                        queryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryParams), {
                                            currentPagePathname: window.location.pathname
                                        })
                                    }
                                },
                                mutation: (0,lib/* default */.ZP)(PromoModal_templateObject())
                            })
                        ];
                    case 1:
                        _state.sent();
                        setSuccessfulSubmit(true);
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            initialValues: {
                phoneNumber: ""
            },
            enableReinitialize: false,
            validationSchema: validationSchema,
            onSubmit: onSubmit,
            children: function(param) {
                var isSubmitting = param.isSubmitting, values = param.values;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                    children: successfulSubmit ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "border-2 border-black bg-white text-center italic p-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    postSubmissionText1,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    (0,string_utils/* formatPhoneNumber */.u)(values.phoneNumber),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: postSubmissionText2
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: "phoneNumber",
                                component: CustomTextField/* PhoneNumberField */.g8,
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                className: "w-full py-3",
                                disabled: isSubmitting,
                                type: "submit",
                                id: "submit-btn",
                                children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: faSpinner/* faSpinner */.LM,
                                    spin: true
                                }) : buttonText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center pt-2",
                                children: buttonHelpText
                            })
                        ]
                    })
                });
            }
        })
    });
};
var PromoModal = function(param) {
    var header = param.header, subHeader = param.subHeader, _promoContent = param.promoContent, promoContent = _promoContent === void 0 ? "" : _promoContent, buttonText = param.buttonText, buttonHelpText = param.buttonHelpText, postSubmissionText1 = param.postSubmissionText1, postSubmissionText2 = param.postSubmissionText2, delayMS = param.delayMS, _modalEnabled = param.modalEnabled, modalEnabled = _modalEnabled === void 0 ? true : _modalEnabled;
    var closeModal = function closeModal() {
        setIsOpen(false);
    };
    var modalStyle = {
        content: {
            maxWidth: "360px",
            flexDirection: "column"
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)"
        }
    };
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), modalIsOpen = ref[0], setIsOpen = ref[1];
    var toggleModal = react.useCallback(function() {
        setIsOpen(function(open) {
            return !open;
        });
    }, [
        setIsOpen
    ]);
    react.useEffect(function() {
        var modalTimeout = setTimeout(function() {
            toggleModal();
        }, delayMS);
        return function() {
            return clearTimeout(modalTimeout);
        };
    }, []);
    if (!modalEnabled) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NuModal, {
        preventScroll: true,
        contentLabel: header,
        toggleModal: toggleModal,
        isOpen: modalIsOpen,
        onRequestClose: closeModal,
        shouldCloseOnOverlayClick: true,
        modalStyle: modalStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-2 lg:px-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "w-full px-2 lg:px-0 mx-auto text-nugray text-center mt-0 mb-1 leading-tight",
                    children: subHeader
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoModalContent, {
                    buttonText: buttonText,
                    buttonHelpText: buttonHelpText,
                    postSubmissionText1: postSubmissionText1,
                    postSubmissionText2: postSubmissionText2,
                    promoContent: promoContent
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Builder/components/GetAQuoteButton.tsx








function GetAQuoteButton(props) {
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: {
                pathname: "/get-quote/",
                query: query
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetAQuoteButton_Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "w-full block sm:w-auto sm:inline",
                    style: {
                        paddingTop: 12,
                        paddingBottom: 12,
                        paddingLeft: 30,
                        paddingRight: 30,
                        color: props.textColor || "white"
                    }
                }, props.buttonProps), {
                    children: props.buttonText
                }))
            })
        })
    });
}
var GetAQuoteButton_Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block bg-lime hover:bg-green-600 justify-center text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        disabled: disabled,
        className: classnames_default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};

// EXTERNAL MODULE: ./src/components/clients/nest-backend.client.ts
var nest_backend_client = __webpack_require__(18037);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
;// CONCATENATED MODULE: ./src/components/Builder/components/AcceptPromotionsForm.tsx











var AcceptPromotionsForm_validationSchema = yup_es/* object */.Ry().shape({
    phoneNumber: yup_es/* string */.Z_().required("Required").min(7, "Phone number is not valid").matches(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/, "Phone number is not valid"),
    accept: yup_es/* boolean */.O7().required("you must accept").isTrue("you must accept")
});
var AcceptPromotionsForm = function(param) {
    var checkboxText = param.checkboxText, termsAndConditionsText = param.termsAndConditionsText, submitText = param.submitText;
    function onSubmit(values) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, formattedPhone, error, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        formattedPhone = values === null || values === void 0 ? void 0 : (ref = values.phoneNumber) === null || ref === void 0 ? void 0 : ref.replace(/-/g, "");
                        if (!values.accept) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            nest_backend_client/* nestBackendClient.post */.u.post("/contacts/allow-campaign-messages", {
                                phone: formattedPhone
                            })
                        ];
                    case 2:
                        _state.sent();
                        (0,dist/* default */.ZP)("Thank you, preferences updated!", {
                            duration: 4000,
                            icon: "✅"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0,dist/* default */.ZP)((ref3 = (ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) !== null && ref3 !== void 0 ? ref3 : error.message, {
                            icon: "❌",
                            duration: 2000
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            validationSchema: AcceptPromotionsForm_validationSchema,
            initialValues: {
                phoneNumber: ""
            },
            enableReinitialize: false,
            isInitialValid: false,
            onSubmit: onSubmit,
            children: function(param) {
                var isSubmitting = param.isSubmitting, isValid = param.isValid, handleSubmit = param.handleSubmit;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                    className: "flex flex-col w-full max-w-lg p-3",
                    onSubmitCapture: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                            name: "phoneNumber",
                            component: CustomTextField/* PhoneNumberField */.g8,
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                    name: "accept",
                                    componet: CustomTextField/* CustomFormControl */.Jt,
                                    type: "checkbox",
                                    id: "accept-check"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* Label */.__, {
                                    className: "ml-2",
                                    htmlFor: "accept-check",
                                    children: checkboxText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: termsAndConditionsText
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            className: "w-full py-3",
                            disabled: isSubmitting || !isValid,
                            type: "submit",
                            id: "submit-btn",
                            children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faSpinner */.LM3,
                                spin: true
                            }) : submitText || "Submit"
                        })
                    ]
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Builder/registration/ComponentRegistration.tsx















builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(GetAQuoteButton, {
    name: "Get A Quote Button",
    inputs: [
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Get a Quote"
        },
        {
            name: "textColor",
            type: "string",
            defaultValue: "white"
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(PromoModal, {
    name: "Promo Modal",
    inputs: [
        {
            name: "header",
            type: "string",
            defaultValue: "GET 10% OFF YOUR FIRST SERVICE"
        },
        {
            name: "subHeader",
            type: "string",
            defaultValue: "Save 3.5 hours and up to 30% on shop prices with NuBrakes at-home vehicle service."
        },
        {
            name: "buttonHelpText",
            type: "string",
            defaultValue: "We'll text a discount code to your phone"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "SEND ME A CODE"
        },
        {
            name: "postSubmissionText1",
            type: "string",
            defaultValue: "We sent your 10% off promo code to "
        },
        {
            name: "postSubmissionText2",
            type: "string",
            defaultValue: "To redeem, you must schedule an appointment within 48 hours, so we hope to see you soon!"
        },
        {
            name: "promoContent",
            type: "string",
            defaultValue: "",
            helperText: "For internal use"
        },
        {
            name: "delayMS",
            type: "number",
            defaultValue: 1500
        },
        {
            name: "modalEnabled",
            type: "boolean",
            defaultValue: true
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderOurTechniciansWithChildren, {
    name: "Case Study",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Our Technicians"
        },
        {
            name: "subtitle",
            type: "richText",
            defaultValue: "Brake repair is what we do. A 'wow' customer experience is what we offer."
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(CallUsNowBar_CallUsNowBar, {
    name: "Call Us Now Stripe",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Schedule A Brake Repair Or Get A Quote Now."
        },
        {
            name: "phoneNumber",
            type: "string",
            defaultValue: "8558005629"
        },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: "#f04f23"
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(FAIcon, {
    name: "Font Awesome Icon",
    inputs: [
        {
            name: "icon",
            helperText: "DuoTone Kit",
            type: "string",
            enum: (0,_to_consumable_array/* default */.Z)(faIconNameList),
            defaultValue: "acorn"
        },
        {
            name: "iconColor",
            type: "color",
            defaultValue: "#f04f23"
        },
        {
            name: "iconSize",
            type: "string",
            enum: [
                "xs",
                "lg",
                "2x",
                "3x",
                "4x",
                "5x",
                "6x",
                "7x",
                "8x",
                "9x",
                "10x"
            ],
            defaultValue: "lg",
            helperText: "xs, lg, xl or multiplier of font size"
        }, 
    ]
});
var BuilderBookFacts = (0,builder_react_es5/* withChildren */.u7)(BookFactsSection);
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderBookFacts, {
    name: "Book Facts Section",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Book Facts"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "Book Facts"
        },
        {
            name: "leftColumnTitle",
            type: "string",
            defaultValue: "Left Column Title"
        },
        {
            name: "leftColumnText",
            type: "richText",
            defaultValue: "<p>Left Column Description</p>"
        },
        {
            name: "rightColumnTitle",
            type: "string",
            defaultValue: "Right Column Title"
        },
        {
            name: "rightColumnText",
            type: "string",
            defaultValue: "Right Column Description"
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(CityNearYouSection, {
    name: "Cities Near You",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "We’re the closest mobile brake repair service in South Houston near you. Skip waiting in line at the repair shop, we come to you!"
        },
        {
            name: "description",
            type: "richText",
            defaultValue: '<p>We bring the brake shop to you. Find the best <a href="https://nubrakes.com/brake-repair-near-me/">brake repair near you</a> now.</p>'
        },
        {
            name: "phoneNumberTxt",
            type: "string",
            defaultValue: "(855) 800-5629"
        },
        {
            name: "phoneNumber",
            type: "string",
            defaultValue: "8558005629"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Get A Free Brake Service Estimate"
        },
        {
            name: "buttonColor",
            type: "color",
            defaultValue: "#000"
        },
        {
            name: "listOfMinorCities",
            type: "string"
        }, 
    ],
    defaultStyles: {
        textAlign: "center"
    }
});
var BuilderCityFAQSection = function(param) {
    var cityName = param.cityName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {
        title: "Frequently Asked ".concat(cityName, " Repair Questions"),
        description: "Learn more about our ".concat(cityName, " brake repair operations"),
        faqs: [
            {
                question: "How is NuBrakes different from other ".concat(cityName, " brake repairs near me?"),
                answer: "NuBrakes provides a modern approach to brake repair and replacements by providing an on-demand style service that comes to you. Unlike traditional ".concat(cityName, " brake service shops that require to you to wait in the lobby while the brake repair is being done, use poor quality parts, and lack transparent pricing; NuBrakes will start by sending you a transparent quote, upon your approval, a NuBrakes ASE-certified technician will come to you with everything they need to repair your brakes. We want to save you time and provide you with a trustworthy and transparent diagnosis and repair quote for your ").concat(cityName, ". To request a quote, simply click here, fill out your vehicle information and brake symptoms, and we’ll send you a quote for your ").concat(cityName, " brake service in under an hour.")
            },
            {
                question: "Are your ".concat(cityName, " brake service technicians ASE-certified?"),
                answer: "Absolutely. Every NuBrakes ".concat(cityName, " brake repair technician has years of industry experience and has been certified by The National Institute for Automotive Service Excellence (ASE). Our technicians have a depth of knowledge in all forms of vehicle repair, but brake repair is our core service and specialty.")
            },
            {
                question: "Why should I choose mobile brake repair?",
                answer: "We’re a firm believer that your time, energy, and a trustworthy service provider is much more valuable than spending your Saturday afternoon at the brake repair shop. We’ve built the NuBrakes service so that you can efficiently receive a quote and schedule a mobile brake repair service that comes to you, with just a few clicks. There’s not enough time in the day and we think you should spend more time doing what you love and waiting at the brake repair shop is not it. Not to mention, many brake repair shops will quote you more than you need to spend, and often suggest you repair or replace brake parts when it is not necessary. What’s better than saving time and money?"
            },
            {
                question: "What type of brake pads does NuBrakes use?",
                answer: "High-quality parts are of the utmost importance when repairing your brakes. At NuBrakes, most frequently we are using professional ceramic or semi-metallic brake pads. These parts offer exceptional performance and are backed by our 24 Month/24,000 Mile warranty."
            },
            {
                question: "How long does it take to repair or replace my brakes?",
                answer: "On average, your mobile brake repair service will take 45-90 minutes, with the average appointment lasting around an hour. If you have any time constraints, we’re happy to coordinate around your schedule."
            },
            {
                question: "What should I expect during my brake repair appointment?",
                answer: "After you request a free brake repair quote, you’ll receive an email within 1 hour that will outline our best guess (based on the symptoms you provided) for the repairs and estimated cost. On the day of your appointment, a NuBrakes technician will arrive with all the tools they need to evaluate your brakes in person. Following the in-person evaluation, your technician will provide you with a formal repair quote. Upon your approval, the technician will complete the brake repair procedure."
            },
            {
                question: "Do you service all ".concat(cityName, " models?"),
                answer: "Yes, we’re able to provide brake service on nearly all ".concat(cityName, " models and trims! All of our mobile brake replacement technicians have all of the necessary tools and experience to repair your brakes no matter the model/year. So whether you’re looking for service on a 328i or an M-class, we can take care of your brake service needs.")
            },
            {
                question: "Do you offer a warranty on the brake repairs?",
                answer: "Yes, your NuBrakes mobile brake repair is backed by our 24 month, 24,000 mile warranty."
            }, 
        ]
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderCityFAQSection, {
    name: "City Page FAQ",
    inputs: [
        {
            name: "cityName",
            type: "string"
        }
    ]
});
var BuilderReviewSection = function(param) {
    var cityName = param.cityName, title = param.title, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var spanish = locale === "es";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsV2Section/* ReviewsV2Section */.r, {
        title: title !== null && title !== void 0 ? title : spanish ? "Rese\xf1as de clientes" : "Customer Reviews",
        first: {
            review: spanish ? "Recibimos un servicio fant\xe1stico y r\xe1pido a un precio justo. Obtuvimos varias cotizaciones y NuBrakes fue el mejor precio y result\xf3 ser el servicio m\xe1s r\xe1pido y mejor. Nuestro t\xe9cnico, Mike, fue conocedor y amable e hizo el trabajo r\xe1pidamente, todo en mi oficina. Sin duda los recomendar\xedamos y usar\xedamos el servicio de nuevo." : "We received fantastic, quick service, at a fair price. We got quite a few quotes and NuBrakes was the best price and it turns out, the quickest and best service. Our technician, Mike, was knowledgeable and friendly and got the job done quickly - all at my office. We would definitely recommend them and use the service again.",
            from: "".concat(cityName),
            reviewer: "Tami F."
        },
        second: {
            from: "".concat(cityName),
            reviewer: "Clinton B.",
            review: spanish ? "Este servicio es incre\xedble. Pagas por trabajo r\xe1pido, conveniente y de buena calidad. La comunicaci\xf3n con Walker fue inmediata y el t\xe9cnico Michael termin\xf3 en la mitad del tiempo cotizado. Usar\xe9 NuBrakes de nuevo en el futuro y lo recomiendo a todos. Vienen a ti, eso fue lo que me convenci\xf3." : "This service is awesome. You are paying for fast, convenient and good quality work. Communication with Walker was immediate and the technician Micheal was done in half the time that was quoted. I will use NuBrakes again in the future and recommend it to everyone. I mean, they come to you, that was what sold it for me."
        },
        third: {
            review: spanish ? "Sin duda recomendar\xeda NuBrakes a cualquiera que necesite frenos. El t\xe9cnico lleg\xf3 a tiempo, fue profesional y r\xe1pido. Y la comodidad de que vengan a ti no tiene precio. Por no mencionar que el precio es casi la mitad de lo que pagar\xedas en Pep Boys u otro taller. Inigualable." : "Without a doubt would recommend NuBrakes to anyone that needs brakes done. Service tech showed up on time and was professional and quick. And the conveniences having them come to you is hard to beat. Not to mention the price is close to half what you’d pay at a pep boys or any other body shop. Can’t beat it.",
            from: "".concat(cityName),
            reviewer: "William T."
        }
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(ReviewsSection/* BuilderReviewsSection */.ot, {
    name: "Reviews Section",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Customer Reviews"
        },
        {
            name: "subtitle",
            type: "string"
        },
        {
            name: "phoneNumber",
            type: "string",
            defaultValue: "(855) 800-5629"
        },
        {
            name: "reviews",
            type: "list",
            subFields: [
                {
                    name: "review",
                    type: "longText",
                    defaultValue: "Enter Review"
                },
                {
                    name: "reviewSource",
                    type: "string",
                    enum: [
                        "google",
                        "facebook",
                        "yelp",
                        "nubrakes"
                    ],
                    defaultValue: "google"
                },
                {
                    name: "customerLocation",
                    type: "string",
                    defaultValue: "Austin, Texas"
                },
                {
                    name: "customerName",
                    type: "string",
                    defaultValue: "Stephen T."
                },
                {
                    name: "reviewLink",
                    type: "string",
                    defaultValue: "https://goo.gl/maps/Ks8Tec69t5x5sFX68"
                }, 
            ]
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderReviewSection, {
    name: "City Review Section",
    inputs: [
        {
            name: "locale",
            type: "string",
            defaultValue: "en",
            enum: [
                "en",
                "es"
            ]
        },
        {
            name: "title",
            type: "string"
        },
        {
            name: "cityName",
            type: "string"
        }, 
    ]
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(AcceptPromotionsForm, {
    name: "accept promotions form",
    inputs: [
        {
            name: "checkboxText",
            type: "string"
        },
        {
            name: "termsAndConditionsText",
            type: "richText"
        },
        {
            name: "submitText",
            type: "string",
            defaultValue: "Submit"
        }
    ]
});

// EXTERNAL MODULE: ./node_modules/param-case/dist.es2015/index.js + 1 modules
var param_case_dist_es2015 = __webpack_require__(34539);
;// CONCATENATED MODULE: ./src/components/LandingPage/CarsRollWhite.tsx










var CarsRollWhite = function(param) {
    var carContent = param.carContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title",
                    children: "Skip The Brake Shop, We Offer Brake Services On Nearly Every Make & Model"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: "Our mobile brake mechanics are experienced and ready to tackle brake repairs on nearly all major makes and models. Plus, we beat most dealership repair quotes by up to 40% on average!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-4 sm:grid-cols-2 gap-4",
                    children: (0,es/* pipe */.zGw)((0,es/* take */.qnb)(8), (0,util/* mapIndexed */.XD)(function(post, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarsRollItem, {
                            logo: post.makeLogo,
                            url: "/cars/".concat((0,param_case_dist_es2015/* paramCase */.o)(post.makeShortName), "-brake-repair/"),
                            makeLongName: post.makeLongName
                        }, index);
                    }))(carContent)
                })
            ]
        })
    });
};
var CarsRollItem = function(param) {
    var logo = param.logo, makeLongName = param.makeLongName, url = param.url;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            as: {
                pathname: url,
                query: query
            },
            href: "/cars/[slug]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "shadow-lg mx-auto",
                        style: {
                            border: "1px solid #dddddd",
                            width: 200,
                            height: 200
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logo,
                            width: 200,
                            height: 200,
                            alt: "".concat(dist_es2015/* capitalCase */.I(makeLongName), " Logo")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-4",
                        children: "".concat(dist_es2015/* capitalCase */.I(makeLongName), " Brake Repair")
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/LandingPage/BrakeRepairNearYouWithCities.tsx
var LandingPage_BrakeRepairNearYouWithCities = __webpack_require__(61042);
// EXTERNAL MODULE: ./src/components/BecomeATechnicianPage/WhatToExpectSection.tsx
var WhatToExpectSection = __webpack_require__(56018);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faHandHoldingUsd.js
var faHandHoldingUsd = __webpack_require__(64951);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faWrench.js
var faWrench = __webpack_require__(88302);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faBoxFull.js
var faBoxFull = __webpack_require__(35100);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faGarageCar.js
var faGarageCar = __webpack_require__(50649);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faShieldCheck.js
var faShieldCheck = __webpack_require__(68481);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faUserHeadset.js
var faUserHeadset = __webpack_require__(10414);
;// CONCATENATED MODULE: ./src/components/LandingPage/HomePageThirdSection.tsx










var HomePageThirdSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: "YOU WON’T FIND A MORE CONVENIENT BRAKE REPAIR SERVICE."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: "Your time is precious, so why waste it sitting around at an shop that tries to sell you on repairs you don’t actually need?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid md:grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection/* ReasonWhyItem */.v, {
                            title: "Save On Time & Money",
                            subheading: "Don’t waste your afternoon at a shop. We save our customers nearly 40% on average over shop pricing, and you never have to leave your couch.",
                            icon: faHandHoldingUsd/* faHandHoldingUsd */.oF
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection/* ReasonWhyItem */.v, {
                            title: "Experienced Brake Mechanics",
                            subheading: "Our certified brake techs have decades of combined experience repairing vehicles, so you’re always in good hands.",
                            icon: faWrench/* faWrench */.kl
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection/* ReasonWhyItem */.v, {
                            title: "Keep Your Vehicle At Your Home or Work",
                            subheading: "Since we come to you, there’s no need to leave your vehicle sitting on a shop lot for hours or even days unattended.",
                            icon: faGarageCar/* faGarageCar */.sQ
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection/* ReasonWhyItem */.v, {
                            title: "Premium Brake Parts",
                            subheading: "We offer premium brake parts with no markup, something that can’t be said by the big box shops.",
                            icon: faBoxFull/* faBoxFull */.vW
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection/* ReasonWhyItem */.v, {
                            title: "NuBrakes Guarantee",
                            subheading: "Our repairs are backed by our NuBrakes Guarantee to provide peace of mind. Read our warranty for more information.",
                            icon: faShieldCheck/* faShieldCheck */.ip
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection/* ReasonWhyItem */.v, {
                            title: "UnMatched Customer Service",
                            subheading: "We’re proud to offer some of the best customer service in the business. From scheduling to general questions, we’ve got your back.",
                            icon: faUserHeadset/* faUserHeadset */.bk
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/FeatureBySection.tsx + 4 modules
var FeatureBySection = __webpack_require__(97257);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var components_GraySection = __webpack_require__(18737);
;// CONCATENATED MODULE: ./src/components/Builder/CodeComponentsRegistration.tsx
// Additional Registrations for other Code Components by Category





// LAYOUTS FOR PAGE TYPES THAT ENCAPSULATE DATA AND PASS INTO COMPONENTS

// HERO HEADERS

// FORMS

// GRID DISPLAY COMPONENTS

// GENERAL GLOBAL SITE COMPONENTS










var DownChevron = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faChevronDown */.ptq,
        size: "3x"
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(DownChevron, {
    name: "Down Chevron Icon"
});
// TODO DEPRECATE THIS LATER ON INLINE HERO LAUNCH
var BuilderSEMPage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SEMVariation, (0,_object_spread/* default */.Z)({}, props));
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderSEMPage, {
    name: "SEM Page Variation"
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(HomePageThirdSection, {
    name: "Home Page Third Section"
});
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(FeatureBySection/* FeatureBySection */.x, {
    name: "Feature By Section"
});
var GraySectionWithChildren = (0,builder_react_es5/* withChildren */.u7)(components_GraySection/* GraySection */.g);
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(GraySectionWithChildren, {
    name: "Gray Section"
});
var BuilderServicesHowItWorksSection = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesHowItWorksSection/* ServicesHowItWorksSection */.S, {
        title: props.title,
        description: props.description,
        steps: (0,_to_consumable_array/* default */.Z)(props.steps),
        phoneNumber: props.phoneNumber,
        buttonText: props.buttonText
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderServicesHowItWorksSection, {
    name: "How It Works Section",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "NuBrakes Mobile Repair"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "Mobile Auto Repair Built for You"
        },
        {
            name: "phoneNumber",
            type: "string"
        },
        {
            name: "buttonText",
            type: "string",
            defaultValue: "Get A Quote"
        },
        {
            name: "buttonColor",
            type: "color",
            defaultValue: "#ffc107"
        },
        {
            name: "steps",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string",
                    defaultValue: "Step 1"
                },
                {
                    name: "description",
                    type: "string",
                    defaultValue: "Step 1 description"
                },
                {
                    name: "stepImage",
                    type: "string",
                    enum: [
                        "faMoneyCheckEditAlt",
                        "faCalendarCheck",
                        "faCarMechanic"
                    ],
                    defaultValue: "faMoneyCheckEditAlt"
                }, 
            ]
        }, 
    ]
});
var BuilderCarsRoll = function(param) {
    var _builderState = param.builderState, carContent = _builderState.state.carContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarsRollWhite, {
        carContent: carContent
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderCarsRoll, {
    name: "Cars Roll"
});
var BuilderHappinessGuaranteeSection = function(param) {
    var title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection/* HappinessGuaranteeSection */.M, {
        title: title,
        description: description
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderHappinessGuaranteeSection, {
    name: "Happiness Guarantee Section",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "The NuBrakes 5-Star Guarantee"
        },
        {
            name: "description",
            type: "string",
            defaultValue: "We want to make the brake repair process simple and frustration-free. If you’re not happy with your repair or replacement, we’ll do everything we can to fix it. Call or message us any day, any time, and we’ll do our best to fix whatever issue you’re having."
        }, 
    ]
});
var BuilderBrakeRepairNearYouWithCities = function(param) {
    var title = param.title, _builderState = param.builderState, cities = _builderState.state.cities;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage_BrakeRepairNearYouWithCities/* BrakeRepairNearYouWithCities */.r, {
        title: title,
        cities: cities
    });
};
builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(BuilderBrakeRepairNearYouWithCities, {
    name: "Near You Cities",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Schedule your mobile brake repair in minutes."
        }
    ]
});


/***/ }),

/***/ 65105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CarBrandGrid; }
/* harmony export */ });
/* unused harmony export CarBrand */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71292);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61275);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6069);
/* harmony import */ var param_case__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34539);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3210);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73401);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);











var CarBrandGrid = function(param) {
    var carContent = param.carContent, title = param.title, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("text-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "title mb-2",
                    children: title
                }),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid md:grid-cols-4 sm:grid-cols-2 gap-4",
                    children: (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zGw)((0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .take */ .qnb)(8), (0,_util_util__WEBPACK_IMPORTED_MODULE_5__/* .mapIndexed */ .XD)(function(post, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CarBrand, {
                            logo: post.makeLogo,
                            url: "/cars/".concat((0,param_case__WEBPACK_IMPORTED_MODULE_9__/* .paramCase */ .o)(post.makeShortName), "-brake-repair/"),
                            makeLongName: post.makeLongName
                        }, index);
                    }))(carContent)
                })
            ]
        })
    });
};
var CarBrand = function(param) {
    var logo = param.logo, makeLongName = param.makeLongName, url = param.url;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_7__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pb-5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            as: {
                pathname: url,
                query: query
            },
            href: "/cars/[slug]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "shadow-lg mx-auto p-1 border-2 border-gray-100 rounded",
                        style: {
                            width: 200,
                            height: 200
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                            src: logo,
                            width: 200,
                            height: 200,
                            alt: "".concat(capital_case__WEBPACK_IMPORTED_MODULE_10__/* .capitalCase */ .I(makeLongName), " Logo")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-4 font-normal text-lg",
                        children: "".concat(capital_case__WEBPACK_IMPORTED_MODULE_10__/* .capitalCase */ .I(makeLongName), " Brake Repair")
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 70397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ HomeScheduleServiceFormHeaderInline; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormMultiStep.tsx + 2 modules
var NoEmailScheduleServiceFormMultiStep = __webpack_require__(42786);
// EXTERNAL MODULE: ./src/components/SEMPage/StarsAndRatings.tsx
var StarsAndRatings = __webpack_require__(39925);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
;// CONCATENATED MODULE: ./public/img/new_tech_1.webp
/* harmony default export */ var new_tech_1 = ({"src":"/_next/static/media/new_tech_1.64e3e124.webp","height":870,"width":1338,"blurDataURL":"data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAADQAQCdASoIAAUAAkA4JbACdAEXfEqmWADOPU/3tEE5j+II87RMykgDgFQNEuF7tLV/HpVHvP3FGRYbPJCbs4P97onAI0lnW/pi/c7sgAA=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/components/SEMPage/getTitleFromUTMS.tsx
var getTitleFromUTMS = __webpack_require__(10090);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./node_modules/capital-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(71292);
// EXTERNAL MODULE: ./src/components/SEMPage/CityPhoneNumberData.tsx
var CityPhoneNumberData = __webpack_require__(21611);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./src/components/Builder/templates/SEMLayoutTemplate.tsx
var SEMLayoutTemplate = __webpack_require__(66612);
;// CONCATENATED MODULE: ./src/components/Builder/components/HeroInline.tsx

















var HomeScheduleServiceFormHeaderInline = function(param) {
    var title = param.title, subtitle = param.subtitle, rating = param.rating, reviewCount = param.reviewCount, image = param.image, _showImage = param.showImage, showImage = _showImage === void 0 ? true : _showImage, _showGradient = param.showGradient, showGradient = _showGradient === void 0 ? true : _showGradient, _showVideo = param.showVideo, showVideo = _showVideo === void 0 ? false : _showVideo, video = param.video, headerTitle = param.headerTitle, _showDynamicTitle = param.showDynamicTitle, showDynamicTitle = _showDynamicTitle === void 0 ? false : _showDynamicTitle, ratingsText = param.ratingsText, isLinkForm = param.isLinkForm, buttonText = param.buttonText, linkTarget = param.linkTarget;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    // TODO refactor the data here
    var city = (0,es/* propOr */.Uth)("", "city", query);
    var type = (0,es/* propOr */.Uth)("", "type", query);
    var make = (0,es/* propOr */.Uth)("", "make", query);
    var content = (0,es/* propOr */.Uth)("", "utm_content", query);
    content = (0,SEMLayoutTemplate/* setContentWithFallbacks */.ZE)(type, content);
    var formalCity = city ? dist_es2015/* capitalCase */.I(city) : "";
    var phoneNumber = city && CityPhoneNumberData/* CityPhoneNumberData */.L[city] ? CityPhoneNumberData/* CityPhoneNumberData */.L[city].phoneNumber : CityPhoneNumberData/* CityPhoneNumberData.default.phoneNumber */.L["default"].phoneNumber;
    var phoneNumberTxt = (0,string_utils/* formatPhoneNumber */.u)(phoneNumber);
    var dynamicTitle = (0,getTitleFromUTMS/* getTitleFromUTMS */.u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "flex relative min-h-[80vh] sm:min-h-[90vh] pb-0 sm:pb-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        zIndex: -100,
                        top: 0,
                        left: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-0 flex justify-center align-center w-full h-full relative",
                        children: showImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full overflow-hidden relative bg-[#111] block mx-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: image !== null && image !== void 0 ? image : new_tech_1,
                                    layout: "responsive",
                                    priority: true,
                                    height: 768,
                                    width: 1200,
                                    alt: "header image background",
                                    className: "mx-auto block bg-radial-dark object-fit-contain md:object-fit-cover lg:object-fill w-full relative h-auto lg:object-top"
                                }),
                                showGradient && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute w-full bottom-1/2 sm:bottom-[300px] md:bottom-[200px] lg:bottom-0 left-0 h-[200px] sm:h-[200px] lg:h-[320px] image-gradient-overlay",
                                    style: {
                                        background: "linear-gradient(to bottom, transparent 0%, #333 50%, #222 90%, #111 100%)",
                                        zIndex: 100
                                    }
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    className: "flex text-center z-10 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-4 mb-6 flex self-end flex-col w-full items-center",
                        children: [
                            showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-3xl w-full order-3 md:order-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-10 md:mb-10 pb-[52%] w-full justify-center flex relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-0 right-0 bottom-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                            className: "w-full h-full",
                                            src: video,
                                            title: "YouTube video player",
                                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inline-wizard max-w-[850px] w-full self-center p-4 lg:mt-0 text-left bg-white rounded-sm shadow-black shadow-lg pb-8 order-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center",
                                        children: [
                                            showDynamicTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "mb-0 mt-1 text-xl sm:text-2xl md:text-3xl lg:text-4xl leading-none title-wizard px-0 sm:px-8 md:px-16",
                                                children: dynamicTitle
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "mb-1 sm:mb-0 mt-1 text-2xl sm:text-3xl md:text-3xl lg:text-4xl leading-none title-wizard px-0 sm:px-8 md:px-16",
                                                children: title
                                            }),
                                            headerTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-gray-500 text-sm sm:text-base md:text-xl mb-2 pb-1 md:mb-2 mt-0 px-8 sm:px-4 leading-tight sub-title-wizard",
                                                children: headerTitle
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoEmailScheduleServiceFormMultiStep/* NoEmailScheduleServiceFormMultiStepCompact */.vf, {
                                        initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA), {
                                            "form-name": "getQuoteScheduleService"
                                        }),
                                        isLinkForm: isLinkForm,
                                        buttonText: buttonText,
                                        linkTarget: linkTarget
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-center text-sm px-8 sm:px-16 mt-2 mb-0 pb-0 leading-tight text-nugrey",
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-1 mb-0 sm:mt-6 lg:mt-1 block text-center order-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inline-block w-full px-3 pt-2 lg:flex lg:flex-col justify-center mt-2 lg:mt-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings/* StarsAndRatings */.G, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-gray-50 leading-tight",
                                            children: [
                                                "NuBrakes is rated",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-red-600 leading-tight font-bold",
                                                    children: " ".concat(rating, "/5 ")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "hidden sm:inline",
                                                    children: "by "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/reviews/",
                                                        query: query
                                                    },
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "-mt-1 sm:mt-0 text-[#cbd0d3] sm:text-gray-50 underline block lg:inline-block",
                                                        children: "".concat(reviewCount, " ").concat(ratingsText)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 66612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ setContentWithFallbacks; },
/* harmony export */   "cZ": function() { return /* binding */ SEMPageTemplateWithChildren; }
/* harmony export */ });
/* unused harmony export SEMLayoutWithChildren */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18202);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22932);
/* harmony import */ var _SEMPage_getTitleFromUTMS__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10090);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42786);
/* harmony import */ var _SEMPage_HeaderSectionVariation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33009);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61275);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71292);
/* harmony import */ var _SEMPage_CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21611);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2638);















var SEMPageTemplate = function(param) {
    var title = param.title, description = param.description, robots = param.robots, showGetQuote = param.showGetQuote, showFooter = param.showFooter, showDefaultHeader = param.showDefaultHeader, ogImage = param.ogImage, rating = param.rating, reviewCount = param.reviewCount, formName = param.formName, children = param.children, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale, callUsNowTitle = param.callUsNowTitle;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var query = router.query;
    var city = (0,ramda__WEBPACK_IMPORTED_MODULE_8__/* .propOr */ .Uth)("", "city", query);
    var type = (0,ramda__WEBPACK_IMPORTED_MODULE_8__/* .propOr */ .Uth)("", "type", query);
    var make = (0,ramda__WEBPACK_IMPORTED_MODULE_8__/* .propOr */ .Uth)("", "make", query);
    var content = (0,ramda__WEBPACK_IMPORTED_MODULE_8__/* .propOr */ .Uth)("", "utm_content", query);
    content = setContentWithFallbacks(type, content);
    var formalCity = city ? capital_case__WEBPACK_IMPORTED_MODULE_10__/* .capitalCase */ .I(city) : "";
    var phoneNumber = city && _SEMPage_CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_9__/* .CityPhoneNumberData */ .L[city] ? _SEMPage_CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_9__/* .CityPhoneNumberData */ .L[city].phoneNumber : _SEMPage_CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_9__/* .CityPhoneNumberData["default"].phoneNumber */ .L["default"].phoneNumber;
    var phoneNumberTxt = (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_11__/* .formatPhoneNumber */ .u)(phoneNumber);
    var headerTitle = (0,_SEMPage_getTitleFromUTMS__WEBPACK_IMPORTED_MODULE_12__/* .getTitleFromUTMS */ .u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    var metaDescription = locale === "es" ? "\xbfNecesitas frenos nuevos? Qu\xe9date en casa y deja que un t\xe9cnico certificado de NuBrakes vaya contigo y repare tus frenos por menos que la mayor\xeda de talleres y concesionarios".concat(formalCity ? " en ".concat(formalCity) : "", ".") : "Need new brakes? Stay at home and let a certified NuBrakes brake tech come to you and repair your brakes for less than most".concat(formalCity ? " ".concat(formalCity) : "", " brake shops and dealerships on average.");
    var metaTitle = locale === "es" ? "Servicios de reparaci\xf3n de frenos accesibles".concat(formalCity ? " en ".concat(formalCity) : "", " | NuBrakes Reparaci\xf3n de Frenos M\xf3vil - Vamos a ti") : "Affordable Brake Repair Services ".concat(formalCity ? " In ".concat(formalCity) : "", " | NuBrakes Mobile Brake Repair - We Come To You");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SEMLayoutWithChildren, {
        description: description,
        robots: robots,
        showGetQuote: showGetQuote,
        showFooter: showFooter,
        title: headerTitle,
        ogImage: ogImage,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        locale: locale,
        callUsNowTitle: callUsNowTitle,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: metaTitle
                    })
                ]
            }),
            showDefaultHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SEMPage_HeaderSectionVariation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                rating: rating,
                formInitialProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_5__/* .twDefaultInitialWizardFormValues */ .oA), {
                    "form-name": formName
                }),
                reviewCount: reviewCount,
                title: title !== null && title !== void 0 ? title : headerTitle,
                locale: locale
            }),
            children
        ]
    });
};
function setContentWithFallbacks(type, content) {
    if (content !== "undefined") {
        return content;
    }
    switch(type){
        case "generic":
            return "";
        case "comp":
            return "brake shop";
        case "vehicle":
            return "";
        case "vehicle-part":
            return "brake-parts";
        case "mm_generic":
            return "auto-parts";
        case "mm_vehicle-part":
            return "auto-parts";
        default:
            return "";
    }
}
// Exported Here for use in order to allow builder children while keeping the Layout Component in tact for other pages
var SEMLayoutWithChildren = (0,_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .withChildren */ .u7)(_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z) // Overall HTML BODY & HEAD
;
var SEMPageTemplateWithChildren = (0,_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .withChildren */ .u7)(SEMPageTemplate) // Layout extended for Builder & Children
;


/***/ }),

/***/ 12049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ContactUsForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82175);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74231);
/* harmony import */ var _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12640);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_quote_form_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53829);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68663);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faSpinner__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92332);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59397);
/* harmony import */ var _clients_new_backend_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36826);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      mutation contactUs($contactUsInput: ContactUsInput!) {\n        contactUs(contactUsInput: $contactUsInput)\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var formSchema = yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
    firstName: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required("Required"),
    lastName: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required("Required"),
    email: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().email().required("Required"),
    message: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required("Required")
});
function submitToBackend(values) {
    return _submitToBackend.apply(this, arguments);
}
function _submitToBackend() {
    _submitToBackend = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values) {
        var formName, rest;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formName = values["form-name"], rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(values, [
                        "form-name"
                    ]);
                    return [
                        4,
                        _clients_new_backend_client__WEBPACK_IMPORTED_MODULE_9__/* .newBackendClient.mutate */ .t.mutate({
                            variables: {
                                contactUsInput: rest
                            },
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(_templateObject())
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _submitToBackend.apply(this, arguments);
}
var ContactUsForm = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Formik */ .J9, {
        initialValues: {
            "form-name": "contact",
            email: "",
            lastName: "",
            firstName: "",
            message: ""
        },
        validationSchema: formSchema,
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    submitToBackend(values),
                                    (0,_util_quote_form_utils__WEBPACK_IMPORTED_MODULE_6__/* .catchAll */ .km)(values)
                                ])
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                router.push("/contact-success/").then(function() {
                                    return window.scrollTo(0, 0);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var isSubmitting = param.isSubmitting;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Form */ .l0, {
                name: "contactForm",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                        type: "hidden",
                        name: "form-name",
                        value: "contactForm"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                            name: "firstName",
                                            component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                            name: "lastName",
                                            component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                            required: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                    name: "email",
                                    type: "email",
                                    component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                    name: "message",
                                    as: "textarea",
                                    component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                    required: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
                        disabled: isSubmitting,
                        type: "submit",
                        children: isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_8__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons_faSpinner__WEBPACK_IMPORTED_MODULE_15__/* .faSpinner */ .LM,
                            spin: true
                        }) : "Submit"
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 89993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ NoEmailScheduleServiceFormMultiStepVariation; },
/* harmony export */   "o": function() { return /* binding */ twDefaultInitialWizardFormValues; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSource__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9326);
/* harmony import */ var _WizardVariation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91416);
/* harmony import */ var _VehicleInfoFormSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94610);
/* harmony import */ var _util_form_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19090);








var twDefaultInitialWizardFormValues = {
    "form-name": "scheduleServiceWizard",
    fullName: "",
    email: (0,_util_form_util__WEBPACK_IMPORTED_MODULE_5__/* .generateFakeEmail */ .W)(null),
    extraInfo: "",
    vehicleYear: "",
    phoneNumber: "",
    zip: "",
    hearAboutUs: "",
    make: "",
    model: "",
    symptoms: "",
    referredById: "",
    source: "",
    serviceUrgency: "",
    referrerSource: ""
};
var NoEmailScheduleServiceFormMultiStepVariation = function(param) {
    var _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? twDefaultInitialWizardFormValues : _initialValues;
    var source = (0,_hooks_useSource__WEBPACK_IMPORTED_MODULE_2__/* .useSource */ .L)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WizardVariation__WEBPACK_IMPORTED_MODULE_3__/* .WizardVariation */ .q, {
        initialValues: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialValues), {
            source: source
        }),
        formPages: [
            {
                element: _VehicleInfoFormSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP,
                validationSchema: _VehicleInfoFormSection__WEBPACK_IMPORTED_MODULE_4__/* .twVehicleInfoValidationSchema */ .fb
            }, 
        ]
    });
};


/***/ }),

/***/ 61042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ BrakeRepairNearYouWithCities; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3210);
/* harmony import */ var _LandingPageButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17743);
/* harmony import */ var _public_img_nubrakes_logo_no_text_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5120);







var BrakeRepairNearYouWithCities = function(param) {
    var title = param.title, phoneNumberTxt = param.phoneNumberTxt, phoneNumber = param.phoneNumber, buttonText = param.buttonText, cities = param.cities;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pb-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: _public_img_nubrakes_logo_no_text_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
                        alt: "NuBrakes Logo",
                        className: "mx-auto"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "title",
                    children: title
                }),
                cities && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "description",
                    children: [
                        "We bring the brake shop to you. Find the best",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "/brake-repair-near-me/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "brake repair near you"
                            })
                        }),
                        " ",
                        "now."
                    ]
                }),
                phoneNumberTxt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "description",
                    children: [
                        "Call us at ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "tel:".concat(phoneNumber),
                            children: phoneNumberTxt
                        }),
                        " to speak with a brake specialist or click the button below to receive a free, no-obligation quote."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid sm:grid-cols-2 md:grid-cols-4 gap-3 text-center sm:text-left",
                    children: cities.map(function(city, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                as: "/cities/".concat(city.slug, "/"),
                                href: "/cities/[slug]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: "".concat(city.cityName, " Brake Repair")
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        paddingTop: "5%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageButton__WEBPACK_IMPORTED_MODULE_5__/* .LandingPageButton */ .K, {
                        buttonText: buttonText ? buttonText : "Get A Free Brake Service Estimate"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 73803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ LoadingIndicator; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);




var LoadingIndicator = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute w-full h-full flex justify-center items-center align-center z-50",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faSpinner */ .LM3,
            size: "5x",
            spin: true,
            className: "text-orange-600"
        })
    });
};


/***/ }),

/***/ 33009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export BuilderHeaderSectionVariation */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3210);
/* harmony import */ var _StarsAndRatings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39925);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73401);
/* harmony import */ var _public_img_nubrakes_van_house_800_num_jpg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5426);
/* harmony import */ var _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormVariation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89993);









var HeaderSectionVariation = function(props) {
    var title = props.title, _rating = props.rating, rating = _rating === void 0 ? "4.94" : _rating, _reviewCount = props.reviewCount, reviewCount = _reviewCount === void 0 ? 6013 : _reviewCount, subtitle = props.subtitle, _locale = props.locale, locale = _locale === void 0 ? "en" : _locale;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_6__/* .useQueryParam */ .W)();
    var resolvedSubtitle = subtitle !== null && subtitle !== void 0 ? subtitle : locale === "es" ? "Ahorramos a nuestros clientes un 40% en promedio vs. precios de taller — agenda reparaciones accesibles sin salir de casa." : "We save our customers 40% on average over shop prices — book affordable repairs without leaving your home.";
    var ratingsText = locale === "es" ? "clientes de reparaci\xf3n de frenos" : "brake repair customers";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-0 text-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "py-8 flex flex-col justify-center align-center",
            style: {
                minHeight: "60vh",
                position: "relative",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: _public_img_nubrakes_van_house_800_num_jpg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                    placeholder: "blur",
                    layout: "fill",
                    priority: true,
                    objectFit: "cover",
                    objectPosition: "bottom center",
                    alt: "NuBrakes Header Variation Image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "overlay",
                    style: {
                        minHeight: "100%",
                        width: "100%",
                        position: "absolute",
                        zIndex: 1,
                        backgroundColor: "rgba(0,0,0,.75)"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid md:grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "md:text-left text-center flex flex-col justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            style: {
                                                fontSize: 32
                                            },
                                            className: "title",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "subheading text-white",
                                            children: resolvedSubtitle
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            style: {
                                                backgroundColor: "rgba(0, 0, 0, 0.69)",
                                                borderRadius: 6
                                            },
                                            className: "p-3 flex-col flex-grow-0 md:flex hidden mr-auto text-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StarsAndRatings__WEBPACK_IMPORTED_MODULE_5__/* .StarsAndRatings */ .G, {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    style: {
                                                        color: "#cbd0d3",
                                                        lineHeight: 1
                                                    },
                                                    children: [
                                                        "NuBrakes is rated ".concat(rating, "/5 by "),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                            href: {
                                                                pathname: "/reviews/",
                                                                query: query
                                                            },
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                style: {
                                                                    color: "#cbd0d3",
                                                                    textDecoration: "underline"
                                                                },
                                                                children: "".concat(reviewCount, " ").concat(ratingsText)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                backgroundColor: "white"
                                            },
                                            className: "flex flex-col p-4 mt-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormVariation__WEBPACK_IMPORTED_MODULE_8__/* .NoEmailScheduleServiceFormMultiStepVariation */ .k, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-3 block md:hidden",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                style: {
                                                    backgroundColor: "rgba(0, 0, 0, 0.69)",
                                                    borderRadius: 6
                                                },
                                                className: "inline-block px-3 py-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StarsAndRatings__WEBPACK_IMPORTED_MODULE_5__/* .StarsAndRatings */ .G, {}),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        style: {
                                                            color: "#cbd0d3",
                                                            lineHeight: 1
                                                        },
                                                        children: [
                                                            "NuBrakes is rated ".concat(rating, "/5 by "),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                href: {
                                                                    pathname: "/reviews/",
                                                                    query: query
                                                                },
                                                                prefetch: false,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    style: {
                                                                        color: "#cbd0d3",
                                                                        textDecoration: "underline"
                                                                    },
                                                                    children: "".concat(reviewCount, " ").concat(ratingsText)
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var BuilderHeaderSectionVariation = function(props) {
    var title = props.title, subtitle = props.subtitle, showRatings = props.showRatings, image = props.image, showImage = props.showImage, showOverlay = props.showOverlay, overlayColor = props.overlayColor, quoteTitle = props.quoteTitle, quoteSubtitle = props.quoteSubtitle, _rating = props.rating, rating = _rating === void 0 ? "4.94" : _rating, _reviewCount = props.reviewCount, reviewCount = _reviewCount === void 0 ? "2502" : _reviewCount;
    var query = useQueryParam();
    return /*#__PURE__*/ _jsx("section", {
        className: "py-0 text-white",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "py-8 flex flex-col justify-center align-center",
            style: {
                minHeight: "60vh",
                position: "relative",
                width: "100%"
            },
            children: [
                showImage && /*#__PURE__*/ _jsx(Image, {
                    src: image !== null && image !== void 0 ? image : backgroundImage,
                    layout: "fill",
                    priority: true,
                    objectFit: "cover",
                    objectPosition: "bottom center",
                    alt: "NuBrakes Header Variation Image"
                }),
                showOverlay && /*#__PURE__*/ _jsx("div", {
                    id: "overlay",
                    style: {
                        minHeight: "100%",
                        width: "100%",
                        position: "absolute",
                        zIndex: 1,
                        backgroundColor: "".concat(overlayColor !== null && overlayColor !== void 0 ? overlayColor : "rgba(0,0,0,.75)")
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ _jsx(Container, {
                        className: "text-center",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid md:grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "md:text-left text-center flex flex-col justify-center",
                                    children: [
                                        /*#__PURE__*/ _jsx("h1", {
                                            style: {
                                                fontSize: 32
                                            },
                                            className: "title",
                                            children: title
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            style: {
                                                fontSize: 18,
                                                marginBottom: 10
                                            },
                                            className: "subheading",
                                            children: subtitle
                                        }),
                                        showRatings && /*#__PURE__*/ _jsxs("div", {
                                            style: {
                                                backgroundColor: "rgba(0, 0, 0, 0.69)",
                                                borderRadius: 6
                                            },
                                            className: "p-3 flex-col flex-grow-0 md:flex hidden mr-auto text-center",
                                            children: [
                                                /*#__PURE__*/ _jsx(StarsAndRatings, {}),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    style: {
                                                        color: "#cbd0d3",
                                                        lineHeight: 1
                                                    },
                                                    children: [
                                                        "NuBrakes is rated ".concat(rating, "/5 by "),
                                                        /*#__PURE__*/ _jsx(Link, {
                                                            href: {
                                                                pathname: "/reviews/",
                                                                query: query
                                                            },
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                style: {
                                                                    color: "#cbd0d3",
                                                                    textDecoration: "underline"
                                                                },
                                                                children: "".concat(reviewCount, " brake repair customers")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mt-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            style: {
                                                backgroundColor: "white"
                                            },
                                            className: "flex flex-col p-4 mt-0",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "text-center text-black",
                                                    children: [
                                                        quoteTitle && /*#__PURE__*/ _jsx("h3", {
                                                            children: quoteTitle
                                                        }),
                                                        quoteSubtitle && /*#__PURE__*/ _jsx("p", {
                                                            children: quoteSubtitle
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(NoEmailScheduleServiceFormMultiStepVariation, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-3 block md:hidden",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                style: {
                                                    backgroundColor: "rgba(0, 0, 0, 0.69)",
                                                    borderRadius: 6
                                                },
                                                className: "inline-block px-3 py-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx(StarsAndRatings, {}),
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        style: {
                                                            color: "#cbd0d3",
                                                            lineHeight: 1
                                                        },
                                                        children: [
                                                            "NuBrakes is rated ".concat(rating, "/5 by "),
                                                            /*#__PURE__*/ _jsx(Link, {
                                                                href: {
                                                                    pathname: "/reviews/",
                                                                    query: query
                                                                },
                                                                prefetch: false,
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    style: {
                                                                        color: "#cbd0d3",
                                                                        textDecoration: "underline"
                                                                    },
                                                                    children: "".concat(reviewCount, " brake repair customers")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSectionVariation);


/***/ }),

/***/ 94014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ot": function() { return /* binding */ BuilderReviewsSection; },
  "m2": function() { return /* binding */ ReviewsSection; }
});

// UNUSED EXPORTS: FiveStar, ReviewComponent

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var GraySection = __webpack_require__(18737);
// EXTERNAL MODULE: ./node_modules/react-star-rating-component/index.js
var react_star_rating_component = __webpack_require__(64396);
var react_star_rating_component_default = /*#__PURE__*/__webpack_require__.n(react_star_rating_component);
// EXTERNAL MODULE: ./src/components/LandingPageButton.tsx
var LandingPageButton = __webpack_require__(17743);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/google-logo-small.png
/* harmony default export */ var google_logo_small = ({"src":"/_next/static/media/google-logo-small.e85007a5.png","height":33,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAANlBMVEXiMjf/xQAyl0jhMzMZd/2lh3j0PxJmfI70Mh0odfmvQWT1Kxr/vwAme+CXj3dudlUqev//rgDoq9BLAAAAEnRSTlMUFlEjeRF8OytYkZkoIYevMIsPokOTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGPgZGBgZOVlYmDg5GIT5GPh52YQYObgYWdh5wAACHwAtgJG/B8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/img/yelp-logo-small.png
/* harmony default export */ var yelp_logo_small = ({"src":"/_next/static/media/yelp-logo-small.693eb999.png","height":33,"width":75,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEVqNDQkJya2Nh4jGiopJyShNyYwKiopKSm0OB+4OCC3Nh4pKSnoTFutAAAADHRSTlMBbHgHiCQVIUheS09m/1dIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVR4nAXBiQEAMAgCsQO09tl/3yYks9K+qFTyMapXam8Cs4APCRsAdAXYmMcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/img/facebook-logo.png
/* harmony default export */ var facebook_logo = ({"src":"/_next/static/media/facebook-logo.1e498a57.png","height":88,"width":450,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUOWaMLWKIPWaQNWaMQW6UOWKX9ElGNAAAABnRSTlOjOq5cb004pTdRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGUlEQVR4nAXBAQEAAAiDMOD2z+yGetMRFPAA+AAW6++EIwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/nubrakes-logo-icon.png
/* harmony default export */ var nubrakes_logo_icon = ({"src":"/_next/static/media/nubrakes-logo-icon.d6113025.png","height":74,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAMFBMVEX////xWC782tH0fFz2m4Hza0X/+fj6xLX2kXX5t6X+8e34rJf1iWr3pY77zL/97OcyQtPoAAAACXBIWXMAABYlAAAWJQFJUiTwAAAALElEQVR4nAXBhwEAIAjAsDIdoP7/rQmon9p3kNEWWwYneOkGotOWKFT67AUfFlgA6fDKDeQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
;// CONCATENATED MODULE: ./src/components/SEMPage/ReviewsSection.tsx

















var FiveStar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_star_rating_component_default()), {
        name: "rating",
        value: 5,
        starCount: 5,
        starColor: "gold",
        editing: false,
        renderStarIcon: function(index, value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: index <= value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faStar */.Tab,
                    color: "gold"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faStar */.Tab,
                    color: "gold"
                })
            });
        },
        renderStarIconHalf: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faStarHalf */.eJY,
                    color: "gold"
                })
            });
        }
    });
};
var ReviewsSection = function(param) {
    var title = param.title, phoneNumber = param.phoneNumber, subtitle = param.subtitle, reviews = param.reviews, rating = param.rating, reviewCount = param.reviewCount, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale, ctaText = param.ctaText, ratingsText = param.ratingsText;
    var resolvedCtaText = ctaText !== null && ctaText !== void 0 ? ctaText : locale === "es" ? "Obtener una cotizaci\xf3n" : "Get A Quote";
    var resolvedRatingsText = ratingsText !== null && ratingsText !== void 0 ? ratingsText : locale === "es" ? "clientes de reparaci\xf3n de frenos" : "brake repair customers";
    var averageLabel = locale === "es" ? "Calificaci\xf3n promedio de" : "Average rating of";
    var fromLabel = locale === "es" ? "de" : "from";
    var callUsLabel = locale === "es" ? "O ll\xe1manos al" : "Or call us at";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiveStar, {})
                }),
                reviewCount && rating && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "description px-6 sm:px-2",
                    children: [
                        averageLabel,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-orange-500 font-bold",
                            children: [
                                rating,
                                "/5"
                            ]
                        }),
                        " ",
                        fromLabel,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "block sm:inline text-orange-500 font-bold text-xl sm:text-base",
                            children: [
                                reviewCount,
                                " ",
                                resolvedRatingsText
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-3 gap-4 mt-8",
                    children: reviews.map(function(value, index) {
                        return /*#__PURE__*/ (0,react.createElement)(ReviewComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                            key: index
                        }));
                    })
                }),
                subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base text-gray-600 mt-4",
                    children: subtitle
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                        buttonText: resolvedCtaText
                    })
                }),
                phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        callUsLabel,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:".concat(phoneNumber),
                            children: (0,string_utils/* formatPhoneNumber */.u)(phoneNumber)
                        })
                    ]
                })
            ]
        })
    });
};
var ReviewComponent = function(param) {
    var review = param.review, customerName = param.customerName, customerLocation = param.customerLocation, reviewLink = param.reviewLink, reviewSource = param.reviewSource;
    var getImageForSource = function(reviewSource) {
        switch(reviewSource){
            case "facebook":
                return facebook_logo;
            case "google":
                return google_logo_small;
            case "yelp":
                return yelp_logo_small;
            default:
                return nubrakes_logo_icon;
        }
    };
    var image = getImageForSource(reviewSource);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col h-100 px-5 bg-white py-4 shadow-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: reviewLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: 80,
                                    height: 30
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: image !== null && image !== void 0 ? image : nubrakes_logo_icon,
                                    alt: "Social Media Source",
                                    layout: "responsive"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FiveStar, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-left pt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        style: {
                            fontSize: 16
                        },
                        children: [
                            "“",
                            review,
                            "”"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-auto text-left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "customer-name font-bold",
                        children: [
                            "— ",
                            customerName,
                            " | ",
                            customerLocation
                        ]
                    })
                })
            ]
        })
    });
};
var defaultReviewData = [
    {
        review: "I called and within 15 minutes had a few price options with no sales pressure. They ordered the parts we agreed upon and came to my office and within 90 minutes my brakes were fixed. No waiting around, no sales pressure and hundreds of dollars less than a traditional repair shop. Highly recommend.",
        reviewSource: "google",
        customerLocation: "Austin, Texas",
        customerName: "Stephen T.",
        reviewLink: "https://goo.gl/maps/Ks8Tec69t5x5sFX68"
    },
    {
        review: "These guys are great. Excellent Customer Service: My experience from the very start with getting a quote and scheduling with Walker, and the technician Mike doing the brake repair job was great. Came to my house on time as expected. No pressure Up-front, no haggle pricing. Much less expensive than going to the dealership. I highly recommend and I will certainly continue to do business with NuBrakes.",
        reviewSource: "yelp",
        customerLocation: "Dallas, Texas",
        customerName: "Reid H.",
        reviewLink: "https://www.yelp.com/biz/nubrakes-mobile-brake-repair-dallas"
    },
    {
        review: "Walker and Michael saved me today after my brakes gave out on my way to Dallas for a conference. Walker was incredibly responsive and able to chat via text while I was in my meeting. He and Michael were informative and knowledgeable. Michael showed up on time and provided quick service; from start to finish the service took less time than my lunch break! I am so grateful for this company and highly recommend them!",
        reviewSource: "facebook",
        customerLocation: "Austin, Texas",
        customerName: "Brittany M.H.",
        reviewLink: "https://www.facebook.com/brittany.m.horvath/posts/10100148148651320"
    }, 
];
var BuilderReviewsSection = function(props) {
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ReviewsSection, (0,_object_spread/* default */.Z)({
        reviews: defaultReviewData,
        rating: (ref = props.builderState) === null || ref === void 0 ? void 0 : (ref1 = ref.state) === null || ref1 === void 0 ? void 0 : ref1.rating,
        reviewCount: (ref2 = props.builderState) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.state) === null || ref3 === void 0 ? void 0 : ref3.reviewCount
    }, props));
};


/***/ }),

/***/ 18037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ nestBackendClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87066);

var nestBackendClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://prod.v1.api.nubrakes-backend.com/"
});


/***/ })

}]);